// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type OptionsLegacyParser,
  formDataBodySerializer,
} from "@hey-api/client-fetch";
import {
  type UsersListApiError,
  type UsersListApiResponse,
  type CacheListError,
  type CacheListResponse2,
  type CompanyHeadersListError,
  type CompanyHeadersListResponse,
  type CompanyHeaderUpsertData,
  type CompanyHeaderUpsertError,
  type CompanyHeaderUpsertResponse,
  type CompanyHeaderDeleteData,
  type CompanyHeaderDeleteError,
  type CompanyHeaderDeleteResponse,
  type CreditTermsListError,
  type CreditTermsListResponse,
  type CreditTermsUpsertData,
  type CreditTermsUpsertError,
  type CreditTermsUpsertResponse,
  type CreditTermsDeleteData,
  type CreditTermsDeleteError,
  type CreditTermsDeleteResponse,
  type CreditTermSettlementsDeleteData,
  type CreditTermSettlementsDeleteError,
  type CreditTermSettlementsDeleteResponse,
  type CreditTermSettlementsUpsertData,
  type CreditTermSettlementsUpsertError,
  type CreditTermSettlementsUpsertResponse,
  type CurrenciesListError,
  type CurrenciesListResponse,
  type CurrenciesUpsertData,
  type CurrenciesUpsertError,
  type CurrenciesUpsertResponse,
  type CurrenciesDeleteData,
  type CurrenciesDeleteError,
  type CurrenciesDeleteResponse,
  type CurrenciesSetPrimaryData,
  type CurrenciesSetPrimaryError,
  type CurrenciesSetPrimaryResponse,
  type CurrenciesUpdateRatesError,
  type CurrenciesUpdateRatesResponse,
  type CustomerPortalsListError,
  type CustomerPortalsListResponse,
  type CustomerPortalsGetData,
  type CustomerPortalsGetError,
  type CustomerPortalsGetResponse,
  type CustomerPortalsUpsertData,
  type CustomerPortalsUpsertError,
  type CustomerPortalsUpsertResponse,
  type DocumentCustomFieldsListError,
  type DocumentCustomFieldsListResponse,
  type DocumentCustomFieldCreateData,
  type DocumentCustomFieldCreateError,
  type DocumentCustomFieldCreateResponse,
  type DocumentCustomFieldDeleteData,
  type DocumentCustomFieldDeleteError,
  type DocumentCustomFieldDeleteResponse,
  type DocumentCustomFieldUpdateData,
  type DocumentCustomFieldUpdateError,
  type DocumentCustomFieldUpdateResponse,
  type DocumentStageListError,
  type DocumentStageListResponse,
  type DocumentStageDeleteData,
  type DocumentStageDeleteError,
  type DocumentStageDeleteResponse,
  type DocumentStageUpsertData,
  type DocumentStageUpsertError,
  type DocumentStageUpsertResponse,
  type DocumentTagsListError,
  type DocumentTagsListResponse,
  type DocumentTagsDeleteData,
  type DocumentTagsDeleteError,
  type DocumentTagsDeleteResponse,
  type DocumentTagsUpsertData,
  type DocumentTagsUpsertError,
  type DocumentTagsUpsertResponse,
  type EmailTemplatesListError,
  type EmailTemplatesListResponse,
  type EmailTemplatesDeleteData,
  type EmailTemplatesDeleteError,
  type EmailTemplatesDeleteResponse,
  type EmailTemplatesGetData,
  type EmailTemplatesGetError,
  type EmailTemplatesGetResponse,
  type EmailTemplatesUpsertData,
  type EmailTemplatesUpsertError,
  type EmailTemplatesUpsertResponse,
  type GlobalSettingsError,
  type GlobalSettingsResponse2,
  type HeaderSequencesCreateData,
  type HeaderSequencesCreateError,
  type HeaderSequencesCreateResponse,
  type HeaderSequencesDeleteData,
  type HeaderSequencesDeleteError,
  type HeaderSequencesDeleteResponse,
  type HeaderSequencesUpdateData,
  type HeaderSequencesUpdateError,
  type HeaderSequencesUpdateResponse,
  type HeaderSequencesDetailsError,
  type HeaderSequencesDetailsResponse,
  type HeaderSequencesNamesError,
  type HeaderSequencesNamesResponse,
  type InboundAsnStatusBadgeDeleteData,
  type InboundAsnStatusBadgeDeleteError,
  type InboundAsnStatusBadgeDeleteResponse,
  type InboundAsnStatusBadgesListError,
  type InboundAsnStatusBadgesListResponse,
  type InboundAsnStatusBadgeUpsertData,
  type InboundAsnStatusBadgeUpsertError,
  type InboundAsnStatusBadgeUpsertResponse,
  type InboundStatusBadgeSetOrderData,
  type InboundStatusBadgeSetOrderError,
  type InboundStatusBadgeSetOrderResponse,
  type InboundShpStatusBadgesListError,
  type InboundShpStatusBadgesListResponse,
  type InboundShpStatusBadgeUpsertData,
  type InboundShpStatusBadgeUpsertError,
  type InboundShpStatusBadgeUpsertResponse,
  type ItemLabelTemplatesListError,
  type ItemLabelTemplatesListResponse,
  type ItemLabelTemplatesDeleteData,
  type ItemLabelTemplatesDeleteError,
  type ItemLabelTemplatesDeleteResponse,
  type ItemLabelTemplatesUpsertData,
  type ItemLabelTemplatesUpsertError,
  type ItemLabelTemplatesUpsertResponse,
  type LanguagesListError,
  type LanguagesListResponse,
  type ListResponseData,
  type ListResponseError,
  type ListResponseResponse,
  type MonitorsListError,
  type MonitorsListResponse,
  type MonitorsDeleteData,
  type MonitorsDeleteError,
  type MonitorsDeleteResponse,
  type MonitorsGetData,
  type MonitorsGetError,
  type MonitorsGetResponse,
  type MonitorsUpsertData,
  type MonitorsUpsertError,
  type MonitorsUpsertResponse,
  type OutgoingEmailsListError,
  type OutgoingEmailsListResponse,
  type OutgoingEmailsDeleteData,
  type OutgoingEmailsDeleteError,
  type OutgoingEmailsDeleteResponse,
  type OutgoingEmailsGetData,
  type OutgoingEmailsGetError,
  type OutgoingEmailsGetResponse,
  type OutgoingEmailsUpsertCustomData,
  type OutgoingEmailsUpsertCustomError,
  type OutgoingEmailsUpsertCustomResponse,
  type OutgoingEmailsUpsertOAuthData,
  type OutgoingEmailsUpsertOAuthError,
  type OutgoingEmailsUpsertOAuthResponse,
  type OutgoingEmailsTestData,
  type OutgoingEmailsTestError,
  type OutgoingEmailsTestResponse,
  type PackageTypesListError,
  type PackageTypesListResponse,
  type PackageTypeUpsertData,
  type PackageTypeUpsertError,
  type PackageTypeUpsertResponse,
  type PackageTypeDeleteData,
  type PackageTypeDeleteError,
  type PackageTypeDeleteResponse,
  type PackageTypesSetOrderData,
  type PackageTypesSetOrderError,
  type PackageTypesSetOrderResponse,
  type PipelinesListError,
  type PipelinesListResponse,
  type PipelinesDeleteData,
  type PipelinesDeleteError,
  type PipelinesDeleteResponse,
  type PipelinesGetData,
  type PipelinesGetError,
  type PipelinesGetResponse,
  type PipelinesUpsertData,
  type PipelinesUpsertError,
  type PipelinesUpsertResponse,
  type PipelinesActivityData,
  type PipelinesActivityError,
  type PipelinesActivityResponse,
  type PipelinesActivityLogData,
  type PipelinesActivityLogError,
  type PipelinesActivityLogResponse,
  type PipelinesTriggerData,
  type PipelinesTriggerError,
  type PipelinesTriggerResponse,
  type PipelinesConfigurationError,
  type PipelinesConfigurationResponse2,
  type PipelinesEndpointError,
  type PipelinesEndpointResponse,
  type PrintQueuesListError,
  type PrintQueuesListResponse,
  type PrintQueuesDeleteData,
  type PrintQueuesDeleteError,
  type PrintQueuesDeleteResponse,
  type PrintQueuesUpsertData,
  type PrintQueuesUpsertError,
  type PrintQueuesUpsertResponse,
  type PrintQueuesPurgeData,
  type PrintQueuesPurgeError,
  type PrintQueuesPurgeResponse,
  type ProfitRatingsListError,
  type ProfitRatingsListResponse,
  type ProfitRatingsUpsertData,
  type ProfitRatingsUpsertError,
  type ProfitRatingsUpsertResponse,
  type ProfitRatingsDeleteData,
  type ProfitRatingsDeleteError,
  type ProfitRatingsDeleteResponse,
  type RctEmbeddedExpenseTypesListError,
  type RctEmbeddedExpenseTypesListResponse,
  type RctEmbeddedExpenseTypesUpsertData,
  type RctEmbeddedExpenseTypesUpsertError,
  type RctEmbeddedExpenseTypesUpsertResponse,
  type ReportPeriodDeleteData,
  type ReportPeriodDeleteError,
  type ReportPeriodDeleteResponse,
  type ReportPeriodUpsertData,
  type ReportPeriodUpsertError,
  type ReportPeriodUpsertResponse,
  type ReportTemplatesListError,
  type ReportTemplatesListResponse,
  type ReportTemplatesDeleteData,
  type ReportTemplatesDeleteError,
  type ReportTemplatesDeleteResponse,
  type ReportTemplateUpsertData,
  type ReportTemplateUpsertError,
  type ReportTemplateUpsertResponse,
  type ReportTemplatesHistoryData,
  type ReportTemplatesHistoryError,
  type ReportTemplatesHistoryResponse,
  type ReportTemplatesSetDefaultData,
  type ReportTemplatesSetDefaultError,
  type ReportTemplatesSetDefaultResponse,
  type SalesOrderReturnReasonsListError,
  type SalesOrderReturnReasonsListResponse,
  type SalesOrderReturnReasonUpsertData,
  type SalesOrderReturnReasonUpsertError,
  type SalesOrderReturnReasonUpsertResponse,
  type SalesOrderReturnReasonDeleteData,
  type SalesOrderReturnReasonDeleteError,
  type SalesOrderReturnReasonDeleteResponse,
  type SqBlockTypesListError,
  type SqBlockTypesListResponse,
  type SqBlockTypesUpsertData,
  type SqBlockTypesUpsertError,
  type SqBlockTypesUpsertResponse,
  type SqBlockTypesDeleteData,
  type SqBlockTypesDeleteError,
  type SqBlockTypesDeleteResponse,
  type SqBlockTypesSetDefaultData,
  type SqBlockTypesSetDefaultError,
  type SqBlockTypesSetDefaultResponse,
  type CountryTaxesError,
  type CountryTaxesResponse,
  type CountryTaxesUpsertData,
  type CountryTaxesUpsertError,
  type CountryTaxesUpsertResponse,
  type TaxGroupsListError,
  type TaxGroupsListResponse,
  type TaxGroupsUpsertData,
  type TaxGroupsUpsertError,
  type TaxGroupsUpsertResponse,
  type TaxGroupsDetailsData,
  type TaxGroupsDetailsError,
  type TaxGroupsDetailsResponse,
  type TaxGroupsSetDefaultData,
  type TaxGroupsSetDefaultError,
  type TaxGroupsSetDefaultResponse,
  type TaxItemsListError,
  type TaxItemsListResponse,
  type TaxItemsUpsertData,
  type TaxItemsUpsertError,
  type TaxItemsUpsertResponse,
  type TaxItemsDeleteData,
  type TaxItemsDeleteError,
  type TaxItemsDeleteResponse,
  type TaxTypesListError,
  type TaxTypesListResponse,
  type TaxTypeUpsertData,
  type TaxTypeUpsertError,
  type TaxTypeUpsertResponse,
  type TaxTypeDeleteData,
  type TaxTypeDeleteError,
  type TaxTypeDeleteResponse,
  type TaxTypeSetDefaultData,
  type TaxTypeSetDefaultError,
  type TaxTypeSetDefaultResponse,
  type UsersListActiveError,
  type UsersListActiveResponse,
  type UsersInviteData,
  type UsersInviteError,
  type UsersInviteResponse,
  type WebhookEndpointsListError,
  type WebhookEndpointsListResponse,
  type WebhookEndpointsUpsertData,
  type WebhookEndpointsUpsertError,
  type WebhookEndpointsUpsertResponse,
  type WebhookEndpointsDeleteData,
  type WebhookEndpointsDeleteError,
  type WebhookEndpointsDeleteResponse,
  type WebhookEndpointsTestData,
  type WebhookEndpointsTestError,
  type WebhookEndpointsTestResponse,
  type WebhookSubscriptionTypesError,
  type WebhookSubscriptionTypesResponse,
  CacheListResponseTransformer,
  CurrenciesListResponseTransformer,
  CurrenciesUpdateRatesResponseTransformer,
  PipelinesListResponseTransformer,
  PipelinesGetResponseTransformer,
  PipelinesActivityResponseTransformer,
  PipelinesActivityLogResponseTransformer,
  ReportTemplatesHistoryResponseTransformer,
  type AmazonInboundPlansCreateData,
  type AmazonInboundPlansCreateError,
  type AmazonInboundPlansCreateResponse2,
  type AmazonInboundPlansListData,
  type AmazonInboundPlansListError,
  type AmazonInboundPlansListResponse,
  type AmazonInboundPlansDetailsData,
  type AmazonInboundPlansDetailsError,
  type AmazonInboundPlansDetailsResponse,
  type AmazonInboundPlansCancelData,
  type AmazonInboundPlansCancelError,
  type AmazonInboundPlansCancelResponse,
  type AmazonInboundPlansHoldingTrnsCreateData,
  type AmazonInboundPlansHoldingTrnsCreateError,
  type AmazonInboundPlansHoldingTrnsCreateResponse,
  type AmazonInboundPlansPackingOptionsConfirmData,
  type AmazonInboundPlansPackingOptionsConfirmError,
  type AmazonInboundPlansPackingOptionsConfirmResponse,
  type AmazonInboundPlansPackingOptionsListData,
  type AmazonInboundPlansPackingOptionsListError,
  type AmazonInboundPlansPackingOptionsListResponse,
  type AmazonInboundPlansPlacementOptionsConfirmData,
  type AmazonInboundPlansPlacementOptionsConfirmError,
  type AmazonInboundPlansPlacementOptionsConfirmResponse,
  type AmazonInboundPlansRenameData,
  type AmazonInboundPlansRenameError,
  type AmazonInboundPlansRenameResponse,
  type AmazonInboundPlansSubmitPackingInformationData,
  type AmazonInboundPlansSubmitPackingInformationError,
  type AmazonInboundPlansSubmitPackingInformationResponse,
  type AmazonSellerFlexImportShipmentData,
  type AmazonSellerFlexImportShipmentError,
  type AmazonSellerFlexImportShipmentResponse,
  type AmazonSellerFlexOrdersMapData,
  type AmazonSellerFlexOrdersMapError,
  type AmazonSellerFlexOrdersMapResponse,
  type AmazonSellerFlexProcessPackagesData,
  type AmazonSellerFlexProcessPackagesError,
  type AmazonSellerFlexProcessPackagesResponse,
  type AmazonSellerFlexRejectShipmentData,
  type AmazonSellerFlexRejectShipmentError,
  type AmazonSellerFlexRejectShipmentResponse,
  type AppsListError,
  type AppsListResponse,
  type AppsGetData,
  type AppsGetError,
  type AppsGetResponse,
  type AppsUpsertData,
  type AppsUpsertError,
  type AppsUpsertResponse,
  type AppsDeleteData,
  type AppsDeleteError,
  type AppsDeleteResponse,
  type AppsConfigurationError,
  type AppsConfigurationResponse,
  type CarriersListError,
  type CarriersListResponse,
  type CarriersUpsertData,
  type CarriersUpsertError,
  type CarriersUpsertResponse,
  type CarriersDeleteData,
  type CarriersDeleteError,
  type CarriersDeleteResponse,
  type CarriersGetData,
  type CarriersGetError,
  type CarriersGetResponse,
  type CarriersConfigurationError,
  type CarriersConfigurationResponse,
  type CarriersServicesData,
  type CarriersServicesError,
  type CarriersServicesResponse,
  type Configurable3PlUpsertData,
  type Configurable3PlUpsertError,
  type Configurable3PlUpsertResponse,
  type Configurable3PlConfigurationError,
  type Configurable3PlConfigurationResponse,
  type IntegrationDictionaryData,
  type IntegrationDictionaryError,
  type IntegrationDictionaryResponse,
  type MarketplacesListAllError,
  type MarketplacesListAllResponse,
  type MarketplacesGetData,
  type MarketplacesGetError,
  type MarketplacesGetResponse,
  type MarketplacesUpsertData,
  type MarketplacesUpsertError,
  type MarketplacesUpsertResponse,
  type MarketplaceDeleteData,
  type MarketplaceDeleteError,
  type MarketplaceDeleteResponse,
  type MarketplaceListedItemsData,
  type MarketplaceListedItemsError,
  type MarketplaceListedItemsResponse,
  type MarketplaceListedItemsBulkUpdateData,
  type MarketplaceListedItemsBulkUpdateError,
  type MarketplaceListedItemsBulkUpdateResponse,
  type MarketplaceListedItemsExportData,
  type MarketplaceListedItemsExportError,
  type MarketplaceListedItemsExportResponse,
  type MarketplaceListedItemsImportData,
  type MarketplaceListedItemsImportError,
  type MarketplaceListedItemsImportResponse,
  type MarketplaceListedItemsSummaryData,
  type MarketplaceListedItemsSummaryError,
  type MarketplaceListedItemsSummaryResponse,
  type MarketplaceListedItemsUpdateData,
  type MarketplaceListedItemsUpdateError,
  type MarketplaceListedItemsUpdateResponse,
  type MarketplacesConfigurationError,
  type MarketplacesConfigurationResponse,
  type MarketplacesGroupsError,
  type MarketplacesGroupsResponse,
  type MarketplacesGroupData,
  type MarketplacesGroupError,
  type MarketplacesGroupResponse,
  AmazonInboundPlansListResponseTransformer,
  AmazonInboundPlansDetailsResponseTransformer,
  AmazonInboundPlansHoldingTrnsCreateResponseTransformer,
  AmazonSellerFlexOrdersMapResponseTransformer,
  AppsConfigurationResponseTransformer,
  CarriersConfigurationResponseTransformer,
  Configurable3PlConfigurationResponseTransformer,
  MarketplacesListAllResponseTransformer,
  MarketplacesGetResponseTransformer,
  MarketplaceListedItemsResponseTransformer,
  MarketplaceListedItemsSummaryResponseTransformer,
  MarketplacesConfigurationResponseTransformer,
  type PostAuthenticationInviteProcessData,
  type PostAuthenticationInviteProcessError,
  type PostAuthenticationInviteProcessResponse,
  type PostAuthenticationInviteStatusData,
  type PostAuthenticationInviteStatusError,
  type PostAuthenticationInviteStatusResponse,
  type PostAuthenticationLoginEmailData,
  type PostAuthenticationLoginEmailError,
  type PostAuthenticationLoginEmailResponse,
  type PostAuthenticationLoginMfaData,
  type PostAuthenticationLoginMfaError,
  type PostAuthenticationLoginMfaResponse,
  type PostAuthenticationLoginMfaNotifyData,
  type PostAuthenticationLoginMfaNotifyError,
  type PostAuthenticationLoginMfaNotifyResponse,
  type PostAuthenticationLoginPasswordData,
  type PostAuthenticationLoginPasswordError,
  type PostAuthenticationLoginPasswordResponse,
  type PostAuthenticationLogoutError,
  type PostAuthenticationLogoutResponse,
  type PostAuthenticationOauthData,
  type PostAuthenticationOauthError,
  type PostAuthenticationOauthResponse,
  type PostAuthenticationPasswordResetRequestData,
  type PostAuthenticationPasswordResetRequestError,
  type PostAuthenticationPasswordResetRequestResponse,
  type PostAuthenticationPasswordResetResponseData,
  type PostAuthenticationPasswordResetResponseError,
  type PostAuthenticationPasswordResetResponseResponse,
  type GetAuthenticationProfileError,
  type GetAuthenticationProfileResponse,
  type PostAuthenticationProfileData,
  type PostAuthenticationProfileError,
  type PostAuthenticationProfileResponse,
  type GetAuthenticationProfileMfaMethodsError,
  type GetAuthenticationProfileMfaMethodsResponse,
  type DeleteAuthenticationProfileMfaMethodsIdData,
  type DeleteAuthenticationProfileMfaMethodsIdError,
  type DeleteAuthenticationProfileMfaMethodsIdResponse,
  type PutAuthenticationProfileMfaMethodsIdDefaultData,
  type PutAuthenticationProfileMfaMethodsIdDefaultError,
  type PutAuthenticationProfileMfaMethodsIdDefaultResponse,
  type PostAuthenticationProfileMfaSetupData,
  type PostAuthenticationProfileMfaSetupError,
  type PostAuthenticationProfileMfaSetupResponse,
  type PostAuthenticationProfileMfaSetupConfirmData,
  type PostAuthenticationProfileMfaSetupConfirmError,
  type PostAuthenticationProfileMfaSetupConfirmResponse,
  type GetAuthenticationProfileMfaTrustedDevicesData,
  type GetAuthenticationProfileMfaTrustedDevicesError,
  type GetAuthenticationProfileMfaTrustedDevicesResponse,
  type DeleteAuthenticationProfileMfaTrustedDevicesDeviceidData,
  type DeleteAuthenticationProfileMfaTrustedDevicesDeviceidError,
  type DeleteAuthenticationProfileMfaTrustedDevicesDeviceidResponse,
  type PostAuthenticationProfilePasswordUpdateData,
  type PostAuthenticationProfilePasswordUpdateError,
  type PostAuthenticationProfilePasswordUpdateResponse,
  type PostAuthenticationTokenData,
  type PostAuthenticationTokenError,
  type PostAuthenticationTokenResponse,
  GetAuthenticationProfileMfaTrustedDevicesResponseTransformer,
  type LoginCreateData,
  type LoginCreateError,
  type LoginCreateResponse,
  type ContactAddressListData,
  type ContactAddressListError,
  type ContactAddressListResponse,
  type ContactsLookupData,
  type ContactsLookupError,
  type ContactsLookupResponse,
  type ContactTagsListError,
  type ContactTagsListResponse,
  type ContactTagsListUpsertData,
  type ContactTagsListUpsertError,
  type ContactTagsListUpsertResponse,
  type ContactTagsListDeleteData,
  type ContactTagsListDeleteError,
  type ContactTagsListDeleteResponse,
  type ContactTagsListBulkOperationData,
  type ContactTagsListBulkOperationError,
  type ContactTagsListBulkOperationResponse,
  type ContactCreateData,
  type ContactCreateError,
  type ContactCreateResponse,
  type ContactEntityData,
  type ContactEntityError,
  type ContactEntityResponse,
  type ContactEntityByCodeData,
  type ContactEntityByCodeError,
  type ContactEntityByCodeResponse,
  type ContactsListData,
  type ContactsListError,
  type ContactsListResponse,
  type ContactUpdateData,
  type ContactUpdateError,
  type ContactUpdateResponse,
  ContactEntityResponseTransformer,
  ContactEntityByCodeResponseTransformer,
  type AppUpdateCheckData,
  type AppUpdateCheckError,
  type AppUpdateCheckResponse,
  type GetDevicesPrintStationData,
  type GetDevicesPrintStationError,
  type GetDevicesPrintStationResponse,
  type PostDevicesPrintStationMappingData,
  type PostDevicesPrintStationMappingError,
  type PostDevicesPrintStationMappingResponse,
  type DocumentAttachmentsListData,
  type DocumentAttachmentsListError,
  type DocumentAttachmentsListResponse,
  type DocumentAttachmentsCreateData,
  type DocumentAttachmentsCreateError,
  type DocumentAttachmentsCreateResponse,
  type ScanToCloudUploadData,
  type ScanToCloudUploadError,
  type ScanToCloudUploadResponse,
  type BulkInsertData,
  type BulkInsertError,
  type BulkInsertResponse,
  type DataExportMonitorListData,
  type DataExportMonitorListError,
  type DataExportMonitorListResponse,
  type DocumentDetailsData,
  type DocumentDetailsError,
  type DocumentDetailsResponse,
  type ExportPendingUpdateData,
  type ExportPendingUpdateError,
  type ExportPendingUpdateResponse,
  type ExportPendingListData,
  type ExportPendingListError,
  type ExportPendingListResponse,
  type ItemSearchData,
  type ItemSearchError,
  type ItemSearchResponse,
  type ItemPriceLookupData,
  type ItemPriceLookupError,
  type ItemPriceLookupResponse,
  type MatchedDocumentAiDetailsData,
  type MatchedDocumentAiDetailsError,
  type MatchedDocumentAiDetailsResponse,
  type MatchedDocumentAiAcceptData,
  type MatchedDocumentAiAcceptError,
  type MatchedDocumentAiAcceptResponse,
  type MatchedDocumentAiConfirmContactData,
  type MatchedDocumentAiConfirmContactError,
  type MatchedDocumentAiConfirmContactResponse,
  type MatchedDocumentAiCreateData,
  type MatchedDocumentAiCreateError,
  type MatchedDocumentAiCreateResponse,
  type DocumentNotesListData,
  type DocumentNotesListError,
  type DocumentNotesListResponse,
  type DocumentNotesAppendData,
  type DocumentNotesAppendError,
  type DocumentNotesAppendResponse,
  type DocumentNotesDeleteData,
  type DocumentNotesDeleteError,
  type DocumentNotesDeleteResponse,
  type PostcodeLookupData,
  type PostcodeLookupError,
  type PostcodeLookupResponse,
  type DocumentQueuesData,
  type DocumentQueuesError,
  type DocumentQueuesResponse,
  type DocumentsSearchData,
  type DocumentsSearchError,
  type DocumentsSearchResponse,
  type GetDocumentsStorageKeyData,
  type PostDocumentsStorageKeyData,
  type DocumentTagsUpdateData,
  type DocumentTagsUpdateError,
  type DocumentTagsUpdateResponse,
  DocumentAttachmentsListResponseTransformer,
  DataExportMonitorListResponseTransformer,
  MatchedDocumentAiDetailsResponseTransformer,
  MatchedDocumentAiConfirmContactResponseTransformer,
  MatchedDocumentAiCreateResponseTransformer,
  DocumentNotesListResponseTransformer,
  DocumentNotesAppendResponseTransformer,
  DocumentQueuesResponseTransformer,
  DocumentsSearchResponseTransformer,
  type GetInboundDocumentAsnData,
  type GetInboundDocumentAsnError,
  type GetInboundDocumentAsnResponse,
  type PurchaseOrderGetData,
  type PurchaseOrderGetError,
  type PurchaseOrderGetResponse,
  type PoListData,
  type PoListError,
  type PoListResponse,
  type GetInboundDocumentShpSearchData,
  type GetInboundDocumentShpSearchError,
  type GetInboundDocumentShpSearchResponse,
  type ItemsMappingData,
  type ItemsMappingError,
  type ItemsMappingResponse2,
  type GetInboundPendingError,
  type GetInboundPendingResponse,
  type CreatePurchaseOrderData,
  type CreatePurchaseOrderError,
  type CreatePurchaseOrderResponse,
  type CreatePurchaseOrdersData,
  type CreatePurchaseOrdersError,
  type CreatePurchaseOrdersResponse,
  type RctDocumentLinkedData,
  type RctDocumentLinkedError,
  type RctDocumentLinkedResponse,
  type ReceiveData,
  type ReceiveError,
  type ReceiveResponse2,
  type ReceiveByDocumentData,
  type ReceiveByDocumentError,
  type ReceiveByDocumentResponse,
  type InboundDocumentGetData,
  type InboundDocumentGetError,
  type InboundDocumentGetResponse,
  type InboundDocumentCreateData,
  type InboundDocumentCreateError,
  type InboundDocumentCreateResponse,
  GetInboundDocumentAsnResponseTransformer,
  PurchaseOrderGetResponseTransformer,
  PoListResponseTransformer,
  GetInboundDocumentShpSearchResponseTransformer,
  ItemsMappingResponseTransformer,
  GetInboundPendingResponseTransformer,
  RctDocumentLinkedResponseTransformer,
  InboundDocumentGetResponseTransformer,
  type PostInventoryAssemblyCreateData,
  type PostInventoryAssemblyCreateError,
  type PostInventoryAssemblyCreateResponse,
  type PostInventoryAssemblyPrepData,
  type PostInventoryAssemblyPrepError,
  type PostInventoryAssemblyPrepResponse,
  type GetInventoryAssemblyWorkOrdersData,
  type GetInventoryAssemblyWorkOrdersError,
  type GetInventoryAssemblyWorkOrdersResponse,
  type GetInventoryAssemblyWorkOrdersIdData,
  type GetInventoryAssemblyWorkOrdersIdError,
  type GetInventoryAssemblyWorkOrdersIdResponse,
  type BinContentData,
  type BinContentError,
  type BinContentResponse,
  type CatalogItemsExportData,
  type CatalogItemsExportError,
  type CatalogItemsExportResponse,
  type ItemCatalogBulkImportData,
  type ItemCatalogBulkImportError,
  type ItemCatalogBulkImportResponse,
  type ItemIdentifierNextEanError,
  type ItemIdentifierNextEanResponse,
  type ItemLabelsDocumentListData,
  type ItemLabelsDocumentListError,
  type ItemLabelsDocumentListResponse,
  type ItemLabelsPrintBulkData,
  type ItemLabelsPrintBulkError,
  type ItemLabelsPrintBulkResponse,
  type ItemLabelsDocumentPrintData,
  type ItemLabelsDocumentPrintError,
  type ItemLabelsDocumentPrintResponse,
  type ItemBasicDetailsData,
  type ItemBasicDetailsError,
  type ItemBasicDetailsResponse,
  type ItemBatchesData,
  type ItemBatchesError,
  type ItemBatchesResponse,
  type ItemContactInfoUpsertData,
  type ItemContactInfoUpsertError,
  type ItemContactInfoUpsertResponse,
  type ItemIdentifierAppendData,
  type ItemIdentifierAppendError,
  type ItemIdentifierAppendResponse,
  type ItemImagesAddData,
  type ItemImagesAddError,
  type ItemImagesAddResponse,
  type ItemImagesDeleteData,
  type ItemImagesDeleteError,
  type ItemImagesDeleteResponse,
  type ItemImageUpdateData,
  type ItemImageUpdateError,
  type ItemImageUpdateResponse,
  type ItemInventoryData,
  type ItemInventoryError,
  type ItemInventoryResponse,
  type ItemInventory3DData,
  type ItemInventory3DError,
  type ItemInventory3DResponse,
  type ItemInventoryLogData,
  type ItemInventoryLogError,
  type ItemInventoryLogResponse,
  type ItemInventoryDrilldownData,
  type ItemInventoryDrilldownError,
  type ItemInventoryDrilldownResponse,
  type ItemPricingData,
  type ItemPricingError,
  type ItemPricingResponse,
  type ItemQuickViewData,
  type ItemQuickViewError,
  type ItemQuickViewResponse,
  type ItemUomData,
  type ItemUomError,
  type ItemUomResponse,
  type ItemVendorCatalogUpsertData,
  type ItemVendorCatalogUpsertError,
  type ItemVendorCatalogUpsertResponse,
  type ItemImagesBulkUpdateData,
  type ItemImagesBulkUpdateError,
  type ItemImagesBulkUpdateResponse,
  type ItemImagesDropData,
  type ItemImagesDropError,
  type ItemImagesDropResponse2,
  type PatchInventoryItemTagsData,
  type PatchInventoryItemTagsError,
  type PatchInventoryItemTagsResponse,
  type ItemsListExportData,
  type ItemsListExportError,
  type ItemsListExportResponse,
  type ItemsListData,
  type ItemsListError,
  type ItemsListResponse,
  type ItemsListBySkusData,
  type ItemsListBySkusError,
  type ItemsListBySkusResponse,
  type ItemsBulkUpsertData,
  type ItemsBulkUpsertError,
  type ItemsBulkUpsertResponse,
  type ItemLookupData,
  type ItemLookupError,
  type ItemLookupResponse,
  type PricelistConditionalUpsertData,
  type PricelistConditionalUpsertError,
  type PricelistConditionalUpsertResponse,
  type PricelistUomUpsertData,
  type PricelistUomUpsertError,
  type PricelistUomUpsertResponse,
  type PricelistPurgeConditionalsData,
  type PricelistPurgeConditionalsError,
  type PricelistPurgeConditionalsResponse,
  type PricelistExportData,
  type PricelistExportError,
  type PricelistExportResponse,
  type PricelistPurgeConditionalsAllError,
  type PricelistPurgeConditionalsAllResponse,
  type PricelistExportAllData,
  type PricelistExportAllError,
  type PricelistExportAllResponse,
  type PricelistEntriesUpsertData,
  type PricelistEntriesUpsertError,
  type PricelistEntriesUpsertResponse,
  type StockSummaryData,
  type StockSummaryError,
  type StockSummaryResponse,
  type StockSummaryDetailedData,
  type StockSummaryDetailedError,
  type StockSummaryDetailedResponse,
  PostInventoryAssemblyCreateResponseTransformer,
  PostInventoryAssemblyPrepResponseTransformer,
  GetInventoryAssemblyWorkOrdersResponseTransformer,
  GetInventoryAssemblyWorkOrdersIdResponseTransformer,
  BinContentResponseTransformer,
  ItemLabelsDocumentListResponseTransformer,
  ItemBatchesResponseTransformer,
  ItemInventory3DResponseTransformer,
  ItemInventoryLogResponseTransformer,
  ItemInventoryDrilldownResponseTransformer,
  ItemPricingResponseTransformer,
  ItemQuickViewResponseTransformer,
  StockSummaryResponseTransformer,
  StockSummaryDetailedResponseTransformer,
  type ItemAppCategoriesDeleteData,
  type ItemAppCategoriesDeleteError,
  type ItemAppCategoriesDeleteResponse,
  type ItemAppCategoriesGetData,
  type ItemAppCategoriesGetError,
  type ItemAppCategoriesGetResponse,
  type ItemAppCategoriesUpsertData,
  type ItemAppCategoriesUpsertError,
  type ItemAppCategoriesUpsertResponse,
  type ItemAppCategoriesSortingData,
  type ItemAppCategoriesSortingError,
  type ItemAppCategoriesSortingResponse,
  type ItemBrandsDeleteData,
  type ItemBrandsDeleteError,
  type ItemBrandsDeleteResponse,
  type ItemBrandsUpsertData,
  type ItemBrandsUpsertError,
  type ItemBrandsUpsertResponse,
  type ItemCatalogsDeleteData,
  type ItemCatalogsDeleteError,
  type ItemCatalogsDeleteResponse,
  type ItemCatalogsUpsertData,
  type ItemCatalogsUpsertError,
  type ItemCatalogsUpsertResponse,
  type ItemCatalogsPurgeData,
  type ItemCatalogsPurgeError,
  type ItemCatalogsPurgeResponse,
  type ItemCategoriesDeleteData,
  type ItemCategoriesDeleteError,
  type ItemCategoriesDeleteResponse,
  type ItemCategoriesUpsertData,
  type ItemCategoriesUpsertError,
  type ItemCategoriesUpsertResponse,
  type ItemImageTagsListError,
  type ItemImageTagsListResponse,
  type ItemImageTagsDeleteData,
  type ItemImageTagsDeleteError,
  type ItemImageTagsDeleteResponse,
  type ItemImageTagsUpsertData,
  type ItemImageTagsUpsertError,
  type ItemImageTagsUpsertResponse,
  type ItemDepartmentsDeleteData,
  type ItemDepartmentsDeleteError,
  type ItemDepartmentsDeleteResponse,
  type ItemDepartmentsUpsertData,
  type ItemDepartmentsUpsertError,
  type ItemDepartmentsUpsertResponse,
  type ItemTagsDeleteData,
  type ItemTagsDeleteError,
  type ItemTagsDeleteResponse,
  type ItemTagsUpsertData,
  type ItemTagsUpsertError,
  type ItemTagsUpsertResponse,
  type ItemViewsListError,
  type ItemViewsListResponse,
  type ItemViewsDeleteData,
  type ItemViewsDeleteError,
  type ItemViewsDeleteResponse,
  type ItemViewsUpsertData,
  type ItemViewsUpsertError,
  type ItemViewsUpsertResponse,
  type ItemViewsFieldDefinitionsError,
  type ItemViewsFieldDefinitionsResponse,
  type InventoryModelsListError,
  type InventoryModelsListResponse,
  type InventoryModelsUpsertData,
  type InventoryModelsUpsertError,
  type InventoryModelsUpsertResponse,
  type InventoryModelsDeleteData,
  type InventoryModelsDeleteError,
  type InventoryModelsDeleteResponse,
  type PimCompletenessListError,
  type PimCompletenessListResponse,
  type PimCompletenessDeleteData,
  type PimCompletenessDeleteError,
  type PimCompletenessDeleteResponse,
  type PimCompletenessUpsertData,
  type PimCompletenessUpsertError,
  type PimCompletenessUpsertResponse,
  type PricelistListError,
  type PricelistListResponse,
  type PricelistUpsertData,
  type PricelistUpsertError,
  type PricelistUpsertResponse,
  type PricelistDeleteData,
  type PricelistDeleteError,
  type PricelistDeleteResponse,
  type PricelistSetDefaultData,
  type PricelistSetDefaultError,
  type PricelistSetDefaultResponse,
  type InventoryProfilesListError,
  type InventoryProfilesListResponse,
  type InventoryProfilesUpsertData,
  type InventoryProfilesUpsertError,
  type InventoryProfilesUpsertResponse,
  type InventoryProfilesDeleteData,
  type InventoryProfilesDeleteError,
  type InventoryProfilesDeleteResponse,
  type ItemSpecificationsListError,
  type ItemSpecificationsListResponse,
  type ItemSpecificationsDeleteData,
  type ItemSpecificationsDeleteError,
  type ItemSpecificationsDeleteResponse,
  type ItemSpecificationsUpsertData,
  type ItemSpecificationsUpsertError,
  type ItemSpecificationsUpsertResponse,
  type ItemSpecificationsExportError,
  type ItemSpecificationsExportResponse,
  type ItemSpecificationsSetOrderData,
  type ItemSpecificationsSetOrderError,
  type ItemSpecificationsSetOrderResponse,
  type TrcClassListError,
  type TrcClassListResponse,
  type TrcClassUpsertData,
  type TrcClassUpsertError,
  type TrcClassUpsertResponse,
  type TrcClassDeleteData,
  type TrcClassDeleteError,
  type TrcClassDeleteResponse,
  type UomListError,
  type UomListResponse,
  type UomUpsertData,
  type UomUpsertError,
  type UomUpsertResponse,
  type UomDeleteData,
  type UomDeleteError,
  type UomDeleteResponse,
  type UomSetDefaultData,
  type UomSetDefaultError,
  type UomSetDefaultResponse,
  type ItemAppCategoriesListError,
  type ItemAppCategoriesListResponse,
  type ItemBrandsListError,
  type ItemBrandsListResponse,
  type ItemCatalogsListError,
  type ItemCatalogsListResponse,
  type ItemCategoriesListError,
  type ItemCategoriesListResponse,
  type ItemDepartmentsListError,
  type ItemDepartmentsListResponse,
  type ItemTagsListError,
  type ItemTagsListResponse,
  ItemAppCategoriesListResponseTransformer,
  type ItemCreateData,
  type ItemCreateError,
  type ItemCreateResponse,
  type InventoryItemsDetailsData,
  type InventoryItemsDetailsError,
  type InventoryItemsDetailsResponse,
  type InventoryItemsListData,
  type InventoryItemsListError,
  type InventoryItemsListResponse,
  type MarketplaceDetailsData,
  type MarketplaceDetailsError,
  type MarketplaceDetailsResponse,
  type AmazonInboundPrepInstructionsData,
  type AmazonInboundPrepInstructionsError,
  type AmazonInboundPrepInstructionsResponse2,
  type AmazonInboundUpdatePrepDetailsData,
  type AmazonInboundUpdatePrepDetailsError,
  type AmazonInboundUpdatePrepDetailsResponse,
  type AmazonInboundPlacementTransportAcceptData,
  type AmazonInboundPlacementTransportAcceptError,
  type AmazonInboundPlacementTransportAcceptResponse,
  type AmazonInboundPlacementTransportListData,
  type AmazonInboundPlacementTransportListError,
  type AmazonInboundPlacementTransportListResponse,
  type AmazonInboundPlanCreateTrnData,
  type AmazonInboundPlanCreateTrnError,
  type AmazonInboundPlanCreateTrnResponse,
  type AmazonInboundPlanPlacementOptionsDetailedListData,
  type AmazonInboundPlanPlacementOptionsDetailedListError,
  type AmazonInboundPlanPlacementOptionsDetailedListResponse,
  type AmazonInboundPlanPlacementOptionsDetailsData,
  type AmazonInboundPlanPlacementOptionsDetailsError,
  type AmazonInboundPlanPlacementOptionsDetailsResponse,
  type AmazonInboundPlanShipmentsListData,
  type AmazonInboundPlanShipmentsListError,
  type AmazonInboundPlanShipmentsListResponse,
  type AmazonInboundPlanTransportationConfirmationData,
  type AmazonInboundPlanTransportationConfirmationError,
  type AmazonInboundPlanTransportationConfirmationResponse,
  type AmazonInboundPlanTransportListData,
  type AmazonInboundPlanTransportListError,
  type AmazonInboundPlanTransportListResponse,
  type MarketplaceListingsListData,
  type MarketplaceListingsListError,
  type MarketplaceListingsListResponse,
  type MarketplaceListingsLoadData,
  type MarketplaceListingsLoadError,
  type MarketplaceListingsLoadResponse,
  type AmazonInboundDocumentListData,
  type AmazonInboundDocumentListError,
  type AmazonInboundDocumentListResponse,
  type GetMarketplacesLinkedServicesError,
  type GetMarketplacesLinkedServicesResponse,
  MarketplaceDetailsResponseTransformer,
  AmazonInboundPlacementTransportListResponseTransformer,
  AmazonInboundPlanPlacementOptionsDetailedListResponseTransformer,
  AmazonInboundPlanPlacementOptionsDetailsResponseTransformer,
  AmazonInboundPlanShipmentsListResponseTransformer,
  AmazonInboundPlanTransportListResponseTransformer,
  AmazonInboundDocumentListResponseTransformer,
  type CarrierAttachmentsData,
  type CarrierAttachmentsError,
  type CarrierAttachmentsResponse,
  type CarrierDocumentsError,
  type CarrierDocumentsResponse,
  type CarrierValidateData,
  type CarrierValidateError,
  type CarrierValidateResponse,
  type GetOutboundDocumentSoDocumentidTrendsData,
  type GetOutboundDocumentSoDocumentidTrendsError,
  type GetOutboundDocumentSoDocumentidTrendsResponse,
  type InvoicesCreateData,
  type InvoicesCreateError,
  type InvoicesCreateResponse2,
  type InvoicesEmailData,
  type InvoicesEmailError,
  type InvoicesEmailResponse,
  type GetPackingDocumentData,
  type GetPackingDocumentError,
  type GetPackingDocumentResponse,
  type PackagesUnassignPlanData,
  type PackagesUnassignPlanError,
  type PackagesUnassignPlanResponse,
  type PackagesUnassignSaveData,
  type PackagesUnassignSaveError,
  type PackagesUnassignSaveResponse,
  type PackagesUnassignListData,
  type PackagesUnassignListError,
  type PackagesUnassignListResponse,
  type PackagesPalletizeData,
  type PackagesPalletizeError,
  type PackagesPalletizeResponse,
  type PickWorkflowsListError,
  type PickWorkflowsListResponse,
  type PickWorkflowsDeleteData,
  type PickWorkflowsDeleteError,
  type PickWorkflowsDeleteResponse,
  type PickWorkflowsUpsertData,
  type PickWorkflowsUpsertError,
  type PickWorkflowsUpsertResponse,
  type PickWorkflowsTriggerData,
  type PickWorkflowsTriggerError,
  type PickWorkflowsTriggerResponse,
  type ShipmentsImportData,
  type ShipmentsImportError,
  type ShipmentsImportResponse,
  type SalesOrderGetData,
  type SalesOrderGetError,
  type SalesOrderGetResponse,
  type SalesOrderAttachDraftShipmentData,
  type SalesOrderAttachDraftShipmentError,
  type SalesOrderAttachDraftShipmentResponse,
  type SalesOrderCreateDraftShipmentData,
  type SalesOrderCreateDraftShipmentError,
  type SalesOrderCreateDraftShipmentResponse,
  type SalesOrderCreateData,
  type SalesOrderCreateError,
  type SalesOrderCreateResponse,
  CarrierDocumentsResponseTransformer,
  GetOutboundDocumentSoDocumentidTrendsResponseTransformer,
  GetPackingDocumentResponseTransformer,
  PackagesUnassignListResponseTransformer,
  SalesOrderGetResponseTransformer,
  type PackagesDeleteData,
  type PackagesDeleteError,
  type PackagesDeleteResponse,
  type PckDeleteData,
  type PckDeleteError,
  type PckDeleteResponse,
  type PckUnclaimData,
  type PckUnclaimError,
  type PckUnclaimResponse,
  type PckActiveListError,
  type PckActiveListResponse,
  type PckCreateData,
  type PckCreateError,
  type PckCreateResponse,
  type PckMergeData,
  type PckMergeError,
  type PckMergeResponse,
  type PckScheduledUpsertData,
  type PckScheduledUpsertError,
  type PckScheduledUpsertResponse,
  type PckScheduledAssignmentData,
  type PckScheduledAssignmentError,
  type PckScheduledAssignmentResponse,
  PckActiveListResponseTransformer,
  type AccountDetailsError,
  type AccountDetailsResponse,
  type ListInvoicesError,
  type ListInvoicesResponse,
  type ListOrdersError,
  type ListOrdersResponse,
  type DownloadOrderData,
  type DownloadOrderError,
  type DownloadOrderResponse,
  type AuthenticateData,
  type AuthenticateError,
  type AuthenticateResponse,
  type ClearBasketError,
  type ClearBasketResponse,
  type BasketError,
  type BasketResponse,
  type BasketSetData,
  type BasketSetError,
  type BasketSetResponse,
  type BasketSummaryError,
  type BasketSummaryResponse,
  type CatalogData,
  type CatalogError,
  type CatalogResponse,
  type CatalogItemsData,
  type CatalogItemsError,
  type CatalogItemsResponse,
  type CheckoutData,
  type CheckoutError,
  type CheckoutResponse,
  type ForgotPasswordData,
  type ForgotPasswordError,
  type ForgotPasswordResponse,
  type PortalInfoData,
  type PortalInfoError,
  type PortalInfoResponse,
  type ItemSpecsData,
  type ItemSpecsError,
  type ItemSpecsResponse,
  type ResetPasswordData,
  type ResetPasswordError,
  type ResetPasswordResponse,
  type TokenAuthenticationData,
  type TokenAuthenticationError,
  type TokenAuthenticationResponse2,
  type UserInfoError,
  type UserInfoResponse,
  ListInvoicesResponseTransformer,
  ListOrdersResponseTransformer,
  CatalogResponseTransformer,
  CatalogItemsResponseTransformer,
  type AiConversationCreateError,
  type AiConversationCreateResponse,
  type AiConversationMessageData,
  type AiConversationMessageError,
  type AiConversationMessageResponse,
  type AiConversationMessageExportData,
  type AiConversationMessageExportError,
  type AiConversationMessageExportResponse,
  type AiConversationMessageFeedbackData,
  type AiConversationMessageFeedbackError,
  type AiConversationMessageFeedbackResponse,
  type AiConversationMessageRetryData,
  type AiConversationMessageRetryError,
  type AiConversationMessageRetryResponse,
  type GetReportsCustomFeedIdKeyData,
  type GetReportsCustomFeedIdKeyError,
  type GetReportsCustomFeedIdKeyResponse,
  type KpiDashboardCreateData,
  type KpiDashboardCreateError,
  type KpiDashboardCreateResponse,
  type KpiDashboardListError,
  type KpiDashboardListResponse,
  type KpiDashboardWidgetsDeleteData,
  type KpiDashboardWidgetsDeleteError,
  type KpiDashboardWidgetsDeleteResponse,
  type KpiDashboardWidgetsUpsertData,
  type KpiDashboardWidgetsUpsertError,
  type KpiDashboardWidgetsUpsertResponse,
  type KpiDashboardWidgetsListData,
  type KpiDashboardWidgetsListError,
  type KpiDashboardWidgetsListResponse,
  type KpiDashboardDeleteData,
  type KpiDashboardDeleteError,
  type KpiDashboardDeleteResponse,
  type KpiDashboardUpdateData,
  type KpiDashboardUpdateError,
  type KpiDashboardUpdateResponse,
  type KpiDashboardData,
  type KpiDashboardError,
  type KpiDashboardResponse,
  type KpiDashboardWidgetsValueData,
  type KpiDashboardWidgetsValueError,
  type KpiDashboardWidgetsValueResponse,
  type KpiDashboardWidgetsUpdatePositionData,
  type KpiDashboardWidgetsUpdatePositionError,
  type KpiDashboardWidgetsUpdatePositionResponse,
  type WidgetTypesError,
  type WidgetTypesResponse,
  type GetReportsListTypesError,
  type GetReportsListTypesResponse,
  type GetReportsReportServerItemsData,
  type GetReportsReportServerItemsError,
  type GetReportsReportServerItemsResponse,
  type GetReportsReportServerSalesData,
  type GetReportsReportServerSalesError,
  type GetReportsReportServerSalesResponse,
  type ReportTemplatesNamesListData,
  type ReportTemplatesNamesListError,
  type ReportTemplatesNamesListResponse,
  type RunReportData,
  type RunReportError,
  type RunReportResponse,
  type ItemSalesDrillDownData,
  type ItemSalesDrillDownError,
  type ItemSalesDrillDownResponse,
  type ItemSalesDrillDownSummaryData,
  type ItemSalesDrillDownSummaryError,
  type ItemSalesDrillDownSummaryResponse,
  type SalesOverviewPerformanceBySectionData,
  type SalesOverviewPerformanceBySectionError,
  type SalesOverviewPerformanceBySectionResponse,
  type GetReportsSalesOverviewPerformanceDailyData,
  type GetReportsSalesOverviewPerformanceDailyError,
  type GetReportsSalesOverviewPerformanceDailyResponse,
  type SalesOverviewPerformanceByItemData,
  type SalesOverviewPerformanceByItemError,
  type SalesOverviewPerformanceByItemResponse,
  type SalesOverviewSummaryByDateData,
  type SalesOverviewSummaryByDateError,
  type SalesOverviewSummaryByDateResponse,
  type SalesOverviewSummaryData,
  type SalesOverviewSummaryError,
  type SalesOverviewSummaryResponse,
  type ScheduledReportsCreateData,
  type ScheduledReportsCreateError,
  type ScheduledReportsCreateResponse,
  type ScheduledReportsListError,
  type ScheduledReportsListResponse,
  type ScheduledReportsDeleteData,
  type ScheduledReportsDeleteError,
  type ScheduledReportsDeleteResponse,
  type ScheduledReportsGetData,
  type ScheduledReportsGetError,
  type ScheduledReportsGetResponse,
  type ScheduledReportsUpdateData,
  type ScheduledReportsUpdateError,
  type ScheduledReportsUpdateResponse,
  type PostReportsSchedulesIdExecuteData,
  type PostReportsSchedulesIdExecuteError,
  type PostReportsSchedulesIdExecuteResponse,
  type GetReportsSoCustomerPeriodicSoidData,
  type GetReportsSoCustomerPeriodicSoidError,
  type GetReportsSoCustomerPeriodicSoidResponse,
  type PutReportsSystemAlertsDismissGroupData,
  type PutReportsSystemAlertsDismissGroupError,
  type PutReportsSystemAlertsDismissGroupResponse,
  type PutReportsSystemAlertsDismissMessageData,
  type PutReportsSystemAlertsDismissMessageError,
  type PutReportsSystemAlertsDismissMessageResponse,
  type GetReportsSystemAlertsGroupsError,
  type GetReportsSystemAlertsGroupsResponse,
  type GetReportsSystemAlertsMessagesData,
  type GetReportsSystemAlertsMessagesError,
  type GetReportsSystemAlertsMessagesResponse,
  WidgetTypesResponseTransformer,
  GetReportsListTypesResponseTransformer,
  ItemSalesDrillDownResponseTransformer,
  SalesOverviewSummaryResponseTransformer,
  ScheduledReportsListResponseTransformer,
  ScheduledReportsGetResponseTransformer,
  GetReportsSoCustomerPeriodicSoidResponseTransformer,
  GetReportsSystemAlertsGroupsResponseTransformer,
  GetReportsSystemAlertsMessagesResponseTransformer,
  type SalesOrdersListData,
  type SalesOrdersListError,
  type SalesOrdersListResponse,
  type SalesOrderMergeData,
  type SalesOrderMergeError,
  type SalesOrderMergeResponse,
  type SalesOrderMergeSuggestionsError,
  type SalesOrderMergeSuggestionsResponse,
  SalesOrdersListResponseTransformer,
  type SegmentsUpsertData,
  type SegmentsUpsertError,
  type SegmentsUpsertResponse,
  type SegmentsGetData,
  type SegmentsGetError,
  type SegmentsGetResponse,
  type SegmentsListData,
  type SegmentsListError,
  type SegmentsListResponse,
  type ApiTokenCreateData,
  type ApiTokenCreateError,
  type ApiTokenCreateResponse2,
  type ApiTokenDetailsError,
  type ApiTokenDetailsResponse2,
  type ApiTokenUpdateData,
  type ApiTokenUpdateError,
  type ApiTokenUpdateResponse,
  type ColumnDisplayData,
  type ColumnDisplayError,
  type ColumnDisplayResponse,
  type EmailValidationRequestError,
  type EmailValidationRequestResponse,
  type SelfInfoError,
  type SelfInfoResponse,
  type QueuedMessagesData,
  type QueuedMessagesError,
  type QueuedMessagesResponse,
  type QueuedMessagesBodyData,
  type QueuedMessagesBodyError,
  type QueuedMessagesBodyResponse,
  type QueuedMessagesDeleteData,
  type QueuedMessagesDeleteError,
  type QueuedMessagesDeleteResponse,
  type QueuedMessagesDismissData,
  type QueuedMessagesDismissError,
  type QueuedMessagesDismissResponse,
  type QueuedMessagesRequeueData,
  type QueuedMessagesRequeueError,
  type QueuedMessagesRequeueResponse,
  type NotificationsData,
  type NotificationsError,
  type NotificationsResponse,
  type NotificationsCountError,
  type NotificationsCountResponse,
  type SupportTicketsReplyData,
  type SupportTicketsReplyError,
  type SupportTicketsReplyResponse,
  type SupportTicketGetData,
  type SupportTicketGetError,
  type SupportTicketGetResponse,
  type SupportTicketsListData,
  type SupportTicketsListError,
  type SupportTicketsListResponse,
  ApiTokenCreateResponseTransformer,
  ApiTokenDetailsResponseTransformer,
  QueuedMessagesResponseTransformer,
  NotificationsResponseTransformer,
  SupportTicketGetResponseTransformer,
  SupportTicketsListResponseTransformer,
  type WarehouseGroupsError,
  type WarehouseGroupsResponse,
  type WarehouseGroupUpsertData,
  type WarehouseGroupUpsertError,
  type WarehouseGroupUpsertResponse,
  type WarehouseGroupsDeleteData,
  type WarehouseGroupsDeleteError,
  type WarehouseGroupsDeleteResponse,
  type WarehousesListError,
  type WarehousesListResponse,
  type WarehouseUpsertData,
  type WarehouseUpsertError,
  type WarehouseUpsertResponse,
  type WarehousesDetailsData,
  type WarehousesDetailsError,
  type WarehousesDetailsResponse,
  type WarehousesDeleteData,
  type WarehousesDeleteError,
  type WarehousesDeleteResponse,
  type WarehouseBinsUpsertData,
  type WarehouseBinsUpsertError,
  type WarehouseBinsUpsertResponse,
  type WarehouseBinsListData,
  type WarehouseBinsListError,
  type WarehouseBinsListResponse,
  type WarehouseBinsSearchData,
  type WarehouseBinsSearchError,
  type WarehouseBinsSearchResponse,
  type WarehouseBinsDeleteData,
  type WarehouseBinsDeleteError,
  type WarehouseBinsDeleteResponse,
  type WarehouseBinsImportData,
  type WarehouseBinsImportError,
  type WarehouseBinsImportResponse,
  type WarehouseZonesListData,
  type WarehouseZonesListError,
  type WarehouseZonesListResponse,
  type WarehouseZoneDeleteData,
  type WarehouseZoneDeleteError,
  type WarehouseZoneDeleteResponse,
  type WarehouseZonesUpsertData,
  type WarehouseZonesUpsertError,
  type WarehouseZonesUpsertResponse,
  WarehouseBinsSearchResponseTransformer,
} from "./types.gen";

export const client = createClient(createConfig());

export class AdministrationService {
  /**
   * 🔒  [ADM202] Users - List Api Users
   * [Operation: usersListApi]
   */
  public static usersListApi<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      UsersListApiResponse,
      UsersListApiError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/api-users",
    });
  }

  /**
   * 🔒 Global cache list
   * [Operation: cacheList]
   */
  public static cacheList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CacheListResponse2,
      CacheListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/cache-list",
      responseTransformer: CacheListResponseTransformer,
    });
  }

  /**
   * 🔒 Company headers - List
   * [Operation: companyHeadersList]
   */
  public static companyHeadersList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CompanyHeadersListResponse,
      CompanyHeadersListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/company-headers",
    });
  }

  /**
   * 🔒 Company headers - Upsert
   * [Operation: companyHeaderUpsert]
   */
  public static companyHeaderUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CompanyHeaderUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CompanyHeaderUpsertResponse,
      CompanyHeaderUpsertError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/administration/company-headers/{id}",
    });
  }

  /**
   * 🔒 Company headers - Delete
   * [Operation: companyHeaderDelete]
   */
  public static companyHeaderDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CompanyHeaderDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      CompanyHeaderDeleteResponse,
      CompanyHeaderDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/company-headers/{id}",
    });
  }

  /**
   * 🔒 Credit terms - List
   * [Operation: creditTermsList]
   */
  public static creditTermsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CreditTermsListResponse,
      CreditTermsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/credit-terms",
    });
  }

  /**
   * 🔒 Credit terms - Upsert
   * [Operation: creditTermsUpsert]
   */
  public static creditTermsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CreditTermsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreditTermsUpsertResponse,
      CreditTermsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/credit-terms/{id}",
    });
  }

  /**
   * 🔒 Credit terms - Delete
   * [Operation: creditTermsDelete]
   */
  public static creditTermsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CreditTermsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      CreditTermsDeleteResponse,
      CreditTermsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/credit-terms/{id}",
    });
  }

  /**
   * 🔒 Credit term settlements - Delete
   * [Operation: creditTermSettlementsDelete]
   */
  public static creditTermSettlementsDelete<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<CreditTermSettlementsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      CreditTermSettlementsDeleteResponse,
      CreditTermSettlementsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/credit-terms/settlements/{id}",
    });
  }

  /**
   * 🔒 Credit term settlements - Upsert
   * [Operation: creditTermSettlementsUpsert]
   */
  public static creditTermSettlementsUpsert<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<CreditTermSettlementsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreditTermSettlementsUpsertResponse,
      CreditTermSettlementsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/credit-terms/settlements/{id}",
    });
  }

  /**
   * 🔒 Currencies - List
   * [Operation: currenciesList]
   */
  public static currenciesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CurrenciesListResponse,
      CurrenciesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/currencies",
      responseTransformer: CurrenciesListResponseTransformer,
    });
  }

  /**
   * 🔒 Currencies - Upsert
   * [Operation: currenciesUpsert]
   */
  public static currenciesUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CurrenciesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CurrenciesUpsertResponse,
      CurrenciesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/currencies",
    });
  }

  /**
   * 🔒 Currencies - Delete
   * [Operation: currenciesDelete]
   */
  public static currenciesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CurrenciesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      CurrenciesDeleteResponse,
      CurrenciesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/currencies/{id}",
    });
  }

  /**
   * 🔒 Currencies - Set primary
   * [Operation: currenciesSetPrimary]
   */
  public static currenciesSetPrimary<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CurrenciesSetPrimaryData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CurrenciesSetPrimaryResponse,
      CurrenciesSetPrimaryError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/currencies/{id}/set-primary",
    });
  }

  /**
   * 🔒 Currencies - Update rates
   * [Operation: currenciesUpdateRates]
   */
  public static currenciesUpdateRates<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      CurrenciesUpdateRatesResponse,
      CurrenciesUpdateRatesError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/currencies/update-rates",
      responseTransformer: CurrenciesUpdateRatesResponseTransformer,
    });
  }

  /**
   * 🔒 Customer portals - List
   * [Operation: customerPortalsList]
   */
  public static customerPortalsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CustomerPortalsListResponse,
      CustomerPortalsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/customer-portals",
    });
  }

  /**
   * 🔒 Customer portals - Get
   * [Operation: customerPortalsGet]
   */
  public static customerPortalsGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CustomerPortalsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CustomerPortalsGetResponse,
      CustomerPortalsGetError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/customer-portals/{id}",
    });
  }

  /**
   * 🔒 Customer portals - Upsert
   * [Operation: customerPortalsUpsert]
   */
  public static customerPortalsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CustomerPortalsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CustomerPortalsUpsertResponse,
      CustomerPortalsUpsertError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/administration/customer-portals/{id}",
    });
  }

  /**
   * 🔒 Document custom fields - List
   * [Operation: documentCustomFieldsList]
   */
  public static documentCustomFieldsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentCustomFieldsListResponse,
      DocumentCustomFieldsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/custom-fields",
    });
  }

  /**
   * 🔒 Document custom fields - Create
   * [Operation: documentCustomFieldCreate]
   */
  public static documentCustomFieldCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<DocumentCustomFieldCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentCustomFieldCreateResponse,
      DocumentCustomFieldCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/custom-fields",
    });
  }

  /**
   * 🔒 Document custom fields - Delete
   * [Operation: documentCustomFieldDelete]
   */
  public static documentCustomFieldDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentCustomFieldDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DocumentCustomFieldDeleteResponse,
      DocumentCustomFieldDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/custom-fields/{id}",
    });
  }

  /**
   * 🔒 Document custom fields - Update
   * [Operation: documentCustomFieldUpdate]
   */
  public static documentCustomFieldUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentCustomFieldUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentCustomFieldUpdateResponse,
      DocumentCustomFieldUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/custom-fields/{id}",
    });
  }

  /**
   * 🔒 Document stages - List
   * [Operation: documentStageList]
   */
  public static documentStageList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentStageListResponse,
      DocumentStageListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/stages",
    });
  }

  /**
   * 🔒 Document tags - Delete
   * [Operation: documentStageDelete]
   */
  public static documentStageDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentStageDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DocumentStageDeleteResponse,
      DocumentStageDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/stages/{id}",
    });
  }

  /**
   * 🔒 Document stages - Upsert
   * [Operation: documentStageUpsert]
   */
  public static documentStageUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentStageUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentStageUpsertResponse,
      DocumentStageUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/stages/{id}",
    });
  }

  /**
   * 🔒 Document tags - List
   * [Operation: documentTagsList]
   */
  public static documentTagsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentTagsListResponse,
      DocumentTagsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/tags",
    });
  }

  /**
   * 🔒 Document tags - Delete
   * [Operation: documentTagsDelete]
   */
  public static documentTagsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentTagsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DocumentTagsDeleteResponse,
      DocumentTagsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/tags/{id}",
    });
  }

  /**
   * 🔒 Document tags - Upsert
   * [Operation: documentTagsUpsert]
   */
  public static documentTagsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentTagsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentTagsUpsertResponse,
      DocumentTagsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/documents/tags/{id}",
    });
  }

  /**
   * 🔒 Email templates - List
   * [Operation: emailTemplatesList]
   */
  public static emailTemplatesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      EmailTemplatesListResponse,
      EmailTemplatesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/email-templates",
    });
  }

  /**
   * 🔒 Email templates - Delete
   * [Operation: emailTemplatesDelete]
   */
  public static emailTemplatesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<EmailTemplatesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      EmailTemplatesDeleteResponse,
      EmailTemplatesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/email-templates/{id}",
    });
  }

  /**
   * 🔒 Email templates - Get
   * [Operation: emailTemplatesGet]
   */
  public static emailTemplatesGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<EmailTemplatesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      EmailTemplatesGetResponse,
      EmailTemplatesGetError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/email-templates/{id}",
    });
  }

  /**
   * 🔒 Email templates - Upsert
   * [Operation: emailTemplatesUpsert]
   */
  public static emailTemplatesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<EmailTemplatesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      EmailTemplatesUpsertResponse,
      EmailTemplatesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/email-templates/{id}",
    });
  }

  /**
   * 🔒 Global settings
   * [Operation: globalSettings]
   */
  public static globalSettings<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GlobalSettingsResponse2,
      GlobalSettingsError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/global-settings",
    });
  }

  /**
   * 🔒 Header sequences - Create
   * [Operation: headerSequencesCreate]
   */
  public static headerSequencesCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<HeaderSequencesCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      HeaderSequencesCreateResponse,
      HeaderSequencesCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/header-sequences",
    });
  }

  /**
   * 🔒 Header sequences - Delete
   * [Operation: headerSequencesDelete]
   */
  public static headerSequencesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<HeaderSequencesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      HeaderSequencesDeleteResponse,
      HeaderSequencesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/header-sequences/{name}",
    });
  }

  /**
   * 🔒 Header sequences - Update
   * [Operation: headerSequencesUpdate]
   */
  public static headerSequencesUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<HeaderSequencesUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      HeaderSequencesUpdateResponse,
      HeaderSequencesUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/header-sequences/{name}",
    });
  }

  /**
   * 🔒 Header sequences - List details
   * [Operation: headerSequencesDetails]
   */
  public static headerSequencesDetails<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      HeaderSequencesDetailsResponse,
      HeaderSequencesDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/header-sequences/details",
    });
  }

  /**
   * 🔒 Header sequences - List names
   * [Operation: headerSequencesNames]
   */
  public static headerSequencesNames<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      HeaderSequencesNamesResponse,
      HeaderSequencesNamesError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/header-sequences/names",
    });
  }

  /**
   * 🔒 Inbound Status badges - Delete
   * [Operation: inboundAsnStatusBadgeDelete]
   */
  public static inboundAsnStatusBadgeDelete<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<InboundAsnStatusBadgeDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      InboundAsnStatusBadgeDeleteResponse,
      InboundAsnStatusBadgeDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/inbound-status-badges/{id}",
    });
  }

  /**
   * 🔒 Inbound ASN status badges - List
   * [Operation: inboundAsnStatusBadgesList]
   */
  public static inboundAsnStatusBadgesList<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      InboundAsnStatusBadgesListResponse,
      InboundAsnStatusBadgesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/inbound-status-badges/asn",
    });
  }

  /**
   * 🔒 Inbound ASN status badges - Upsert
   * [Operation: inboundAsnStatusBadgeUpsert]
   */
  public static inboundAsnStatusBadgeUpsert<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<InboundAsnStatusBadgeUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InboundAsnStatusBadgeUpsertResponse,
      InboundAsnStatusBadgeUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/inbound-status-badges/asn/{id}",
    });
  }

  /**
   * 🔒 Inbound status badges - Set order
   * [Operation: inboundStatusBadgeSetOrder]
   */
  public static inboundStatusBadgeSetOrder<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<InboundStatusBadgeSetOrderData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InboundStatusBadgeSetOrderResponse,
      InboundStatusBadgeSetOrderError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/inbound-status-badges/set-order",
    });
  }

  /**
   * 🔒 Inbound SHP status badges - List
   * [Operation: inboundShpStatusBadgesList]
   */
  public static inboundShpStatusBadgesList<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      InboundShpStatusBadgesListResponse,
      InboundShpStatusBadgesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/inbound-status-badges/shp",
    });
  }

  /**
   * 🔒 Inbound SHP status badges - Upsert
   * [Operation: inboundShpStatusBadgeUpsert]
   */
  public static inboundShpStatusBadgeUpsert<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<InboundShpStatusBadgeUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InboundShpStatusBadgeUpsertResponse,
      InboundShpStatusBadgeUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/inbound-status-badges/shp/{id}",
    });
  }

  /**
   * 🔒 Item label templates - List
   * [Operation: itemLabelTemplatesList]
   */
  public static itemLabelTemplatesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemLabelTemplatesListResponse,
      ItemLabelTemplatesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/item-label-templates",
    });
  }

  /**
   * 🔒 Item label templates - Delete
   * [Operation: itemLabelTemplatesDelete]
   */
  public static itemLabelTemplatesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemLabelTemplatesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemLabelTemplatesDeleteResponse,
      ItemLabelTemplatesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/item-label-templates/{id}",
    });
  }

  /**
   * 🔒 Item label templates - Upsert
   * [Operation: itemLabelTemplatesUpsert]
   */
  public static itemLabelTemplatesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemLabelTemplatesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemLabelTemplatesUpsertResponse,
      ItemLabelTemplatesUpsertError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/administration/item-label-templates/{id}",
    });
  }

  /**
   * 🔒 Languages - List
   * [Operation: languagesList]
   */
  public static languagesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      LanguagesListResponse,
      LanguagesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/languages",
    });
  }

  /**
   * 🔒 List response
   * [Operation: listResponse]
   */
  public static listResponse<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ListResponseData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ListResponseResponse,
      ListResponseError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/list-response/{listType}",
    });
  }

  /**
   * 🔒 Monitors - List all
   * [Operation: monitorsList]
   */
  public static monitorsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MonitorsListResponse,
      MonitorsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/monitors",
    });
  }

  /**
   * 🔒 Monitors - Delete
   * [Operation: monitorsDelete]
   */
  public static monitorsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MonitorsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      MonitorsDeleteResponse,
      MonitorsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/monitors/{id}",
    });
  }

  /**
   * 🔒 Monitors - Get
   * [Operation: monitorsGet]
   */
  public static monitorsGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MonitorsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MonitorsGetResponse,
      MonitorsGetError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/monitors/{id}",
    });
  }

  /**
   * 🔒 Monitor - Upsert
   * [Operation: monitorsUpsert]
   */
  public static monitorsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MonitorsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MonitorsUpsertResponse,
      MonitorsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/monitors/{id}",
    });
  }

  /**
   * 🔒 Outgoing Emails - List
   * [Operation: outgoingEmailsList]
   */
  public static outgoingEmailsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      OutgoingEmailsListResponse,
      OutgoingEmailsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/outgoing-emails",
    });
  }

  /**
   * 🔒 Outgoing Emails - Delete
   * [Operation: outgoingEmailsDelete]
   */
  public static outgoingEmailsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<OutgoingEmailsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      OutgoingEmailsDeleteResponse,
      OutgoingEmailsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/outgoing-emails/{id}",
    });
  }

  /**
   * 🔒 Outgoing Emails - Get
   * [Operation: outgoingEmailsGet]
   */
  public static outgoingEmailsGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<OutgoingEmailsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      OutgoingEmailsGetResponse,
      OutgoingEmailsGetError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/outgoing-emails/{id}",
    });
  }

  /**
   * 🔒 Outgoing Emails - Upsert (Custom)
   * [Operation: outgoingEmailsUpsertCustom]
   */
  public static outgoingEmailsUpsertCustom<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<OutgoingEmailsUpsertCustomData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      OutgoingEmailsUpsertCustomResponse,
      OutgoingEmailsUpsertCustomError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/outgoing-emails/{id}/custom",
    });
  }

  /**
   * 🔒 Outgoing Emails - Upsert (OAuth)
   * [Operation: outgoingEmailsUpsertOAuth]
   */
  public static outgoingEmailsUpsertOAuth<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<OutgoingEmailsUpsertOAuthData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      OutgoingEmailsUpsertOAuthResponse,
      OutgoingEmailsUpsertOAuthError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/outgoing-emails/{id}/oauth",
    });
  }

  /**
   * 🔒 Outgoing Emails - Test
   * [Operation: outgoingEmailsTest]
   */
  public static outgoingEmailsTest<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<OutgoingEmailsTestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      OutgoingEmailsTestResponse,
      OutgoingEmailsTestError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/outgoing-emails/{id}/test",
    });
  }

  /**
   * 🔒 Package types - List
   * [Operation: packageTypesList]
   */
  public static packageTypesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PackageTypesListResponse,
      PackageTypesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/package-types",
    });
  }

  /**
   * 🔒 Package types - Upsert
   * [Operation: packageTypeUpsert]
   */
  public static packageTypeUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PackageTypeUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PackageTypeUpsertResponse,
      PackageTypeUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/package-types/{id}",
    });
  }

  /**
   * 🔒 Package types - Delete
   * [Operation: packageTypeDelete]
   */
  public static packageTypeDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PackageTypeDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PackageTypeDeleteResponse,
      PackageTypeDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/package-types/{id}",
    });
  }

  /**
   * 🔒 Package types - Set order
   * [Operation: packageTypesSetOrder]
   */
  public static packageTypesSetOrder<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PackageTypesSetOrderData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PackageTypesSetOrderResponse,
      PackageTypesSetOrderError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/package-types/set-order",
    });
  }

  /**
   * 🔒 Pipelines - List all
   * [Operation: pipelinesList]
   */
  public static pipelinesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PipelinesListResponse,
      PipelinesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines",
      responseTransformer: PipelinesListResponseTransformer,
    });
  }

  /**
   * 🔒 Pipelines - Delete
   * [Operation: pipelinesDelete]
   */
  public static pipelinesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PipelinesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PipelinesDeleteResponse,
      PipelinesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/{id}",
    });
  }

  /**
   * 🔒 Pipelines - Get
   * [Operation: pipelinesGet]
   */
  public static pipelinesGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PipelinesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PipelinesGetResponse,
      PipelinesGetError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/{id}",
      responseTransformer: PipelinesGetResponseTransformer,
    });
  }

  /**
   * 🔒 Pipeline - Upsert
   * [Operation: pipelinesUpsert]
   */
  public static pipelinesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PipelinesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PipelinesUpsertResponse,
      PipelinesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/{id}",
    });
  }

  /**
   * 🔒 Pipeline - Get activity
   * [Operation: pipelinesActivity]
   */
  public static pipelinesActivity<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PipelinesActivityData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PipelinesActivityResponse,
      PipelinesActivityError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/{id}/activity",
      responseTransformer: PipelinesActivityResponseTransformer,
    });
  }

  /**
   * 🔒 Pipeline - Get activity log
   * [Operation: pipelinesActivityLog]
   */
  public static pipelinesActivityLog<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PipelinesActivityLogData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PipelinesActivityLogResponse,
      PipelinesActivityLogError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/{id}/activity/{activityId}",
      responseTransformer: PipelinesActivityLogResponseTransformer,
    });
  }

  /**
   * 🔒 Pipeline - Trigger
   * [Operation: pipelinesTrigger]
   */
  public static pipelinesTrigger<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PipelinesTriggerData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PipelinesTriggerResponse,
      PipelinesTriggerError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/{id}/trigger",
    });
  }

  /**
   * 🔒 Pipeline - Configuration
   * [Operation: pipelinesConfiguration]
   */
  public static pipelinesConfiguration<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PipelinesConfigurationResponse2,
      PipelinesConfigurationError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/configuration",
    });
  }

  /**
   * 🔒 Pipeline - Endpoint
   * [Operation: pipelinesEndpoint]
   */
  public static pipelinesEndpoint<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PipelinesEndpointResponse,
      PipelinesEndpointError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/pipelines/endpoint",
    });
  }

  /**
   * 🔒 Print queues - List
   * [Operation: printQueuesList]
   */
  public static printQueuesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PrintQueuesListResponse,
      PrintQueuesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/print-queues",
    });
  }

  /**
   * 🔒 Print queues - Delete
   * [Operation: printQueuesDelete]
   */
  public static printQueuesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PrintQueuesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PrintQueuesDeleteResponse,
      PrintQueuesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/print-queues/{id}",
    });
  }

  /**
   * 🔒 Print queues - Upsert
   * [Operation: printQueuesUpsert]
   */
  public static printQueuesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PrintQueuesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PrintQueuesUpsertResponse,
      PrintQueuesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/print-queues/{id}",
    });
  }

  /**
   * 🔒 Print queues - Purge
   * [Operation: printQueuesPurge]
   */
  public static printQueuesPurge<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PrintQueuesPurgeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PrintQueuesPurgeResponse,
      PrintQueuesPurgeError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/print-queues/{id}/purge",
    });
  }

  /**
   * 🔒 Profit ratings - List
   * [Operation: profitRatingsList]
   */
  public static profitRatingsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ProfitRatingsListResponse,
      ProfitRatingsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/profit-ratings",
    });
  }

  /**
   * 🔒 Profit ratings - Upsert
   * [Operation: profitRatingsUpsert]
   */
  public static profitRatingsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ProfitRatingsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ProfitRatingsUpsertResponse,
      ProfitRatingsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/profit-ratings/{id}",
    });
  }

  /**
   * 🔒 Profit ratings - Delete
   * [Operation: profitRatingsDelete]
   */
  public static profitRatingsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ProfitRatingsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ProfitRatingsDeleteResponse,
      ProfitRatingsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/profit-ratings/{id}",
    });
  }

  /**
   * 🔒 RCT Embedded Expenses - List
   * [Operation: rctEmbeddedExpenseTypesList]
   */
  public static rctEmbeddedExpenseTypesList<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      RctEmbeddedExpenseTypesListResponse,
      RctEmbeddedExpenseTypesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/rct-embedded-expenses",
    });
  }

  /**
   * 🔒 RCT Embedded Expenses - Upsert
   * [Operation: rctEmbeddedExpenseTypesUpsert]
   */
  public static rctEmbeddedExpenseTypesUpsert<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      RctEmbeddedExpenseTypesUpsertData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      RctEmbeddedExpenseTypesUpsertResponse,
      RctEmbeddedExpenseTypesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/rct-embedded-expenses/{id}",
    });
  }

  /**
   * 🔒 Report period - Delete
   * [Operation: reportPeriodDelete]
   */
  public static reportPeriodDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReportPeriodDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ReportPeriodDeleteResponse,
      ReportPeriodDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/report-periods/{id}",
    });
  }

  /**
   * 🔒 Report period - Upsert
   * [Operation: reportPeriodUpsert]
   */
  public static reportPeriodUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReportPeriodUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ReportPeriodUpsertResponse,
      ReportPeriodUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/report-periods/{id}",
    });
  }

  /**
   * 🔒 Report templates - List
   * [Operation: reportTemplatesList]
   */
  public static reportTemplatesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReportTemplatesListResponse,
      ReportTemplatesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/report-templates",
    });
  }

  /**
   * 🔒 Report templates - Delete
   * [Operation: reportTemplatesDelete]
   */
  public static reportTemplatesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReportTemplatesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ReportTemplatesDeleteResponse,
      ReportTemplatesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/report-templates/{id}",
    });
  }

  /**
   * 🔒 Report templates - Upsert
   * [Operation: reportTemplateUpsert]
   */
  public static reportTemplateUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReportTemplateUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ReportTemplateUpsertResponse,
      ReportTemplateUpsertError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/administration/report-templates/{id}",
    });
  }

  /**
   * 🔒 Report templates - Template history
   * [Operation: reportTemplatesHistory]
   */
  public static reportTemplatesHistory<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReportTemplatesHistoryData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReportTemplatesHistoryResponse,
      ReportTemplatesHistoryError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/report-templates/{id}/history",
      responseTransformer: ReportTemplatesHistoryResponseTransformer,
    });
  }

  /**
   * 🔒 Report templates - Set default
   * [Operation: reportTemplatesSetDefault]
   */
  public static reportTemplatesSetDefault<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReportTemplatesSetDefaultData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      ReportTemplatesSetDefaultResponse,
      ReportTemplatesSetDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/report-templates/{id}/set-default",
    });
  }

  /**
   * 🔒 SO Return Reasons - List
   * [Operation: salesOrderReturnReasonsList]
   */
  public static salesOrderReturnReasonsList<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      SalesOrderReturnReasonsListResponse,
      SalesOrderReturnReasonsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sales-order-return-reasons",
    });
  }

  /**
   * 🔒 SO Return Reasons - Upsert
   * [Operation: salesOrderReturnReasonUpsert]
   */
  public static salesOrderReturnReasonUpsert<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<SalesOrderReturnReasonUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SalesOrderReturnReasonUpsertResponse,
      SalesOrderReturnReasonUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sales-order-return-reasons/{id}",
    });
  }

  /**
   * 🔒 SO Return Reasons - Delete
   * [Operation: salesOrderReturnReasonDelete]
   */
  public static salesOrderReturnReasonDelete<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<SalesOrderReturnReasonDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      SalesOrderReturnReasonDeleteResponse,
      SalesOrderReturnReasonDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sales-order-return-reasons/{id}",
    });
  }

  /**
   * 🔒 SQ Block Types - List
   * [Operation: sqBlockTypesList]
   */
  public static sqBlockTypesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SqBlockTypesListResponse,
      SqBlockTypesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sq-block-types",
    });
  }

  /**
   * 🔒 SQ Block Types - Upsert
   * [Operation: sqBlockTypesUpsert]
   */
  public static sqBlockTypesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SqBlockTypesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SqBlockTypesUpsertResponse,
      SqBlockTypesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sq-block-types/{id}",
    });
  }

  /**
   * 🔒 SQ Block Types - Delete
   * [Operation: sqBlockTypesDelete]
   */
  public static sqBlockTypesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SqBlockTypesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      SqBlockTypesDeleteResponse,
      SqBlockTypesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sq-block-types/{id}",
    });
  }

  /**
   * 🔒 SQ Block Types - Set Default
   * [Operation: sqBlockTypesSetDefault]
   */
  public static sqBlockTypesSetDefault<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SqBlockTypesSetDefaultData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      SqBlockTypesSetDefaultResponse,
      SqBlockTypesSetDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/sq-block-types/{id}/set-default",
    });
  }

  /**
   * 🔒 Country Taxes - List
   * [Operation: countryTaxes]
   */
  public static countryTaxes<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CountryTaxesResponse,
      CountryTaxesError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/country-taxes",
    });
  }

  /**
   * 🔒 Country Taxes - Upsert
   * [Operation: countryTaxesUpsert]
   */
  public static countryTaxesUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CountryTaxesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CountryTaxesUpsertResponse,
      CountryTaxesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/country-taxes",
    });
  }

  /**
   * 🔒 Tax Groups - List
   * [Operation: taxGroupsList]
   */
  public static taxGroupsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      TaxGroupsListResponse,
      TaxGroupsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-groups",
    });
  }

  /**
   * 🔒 Tax Groups - Upsert
   * [Operation: taxGroupsUpsert]
   */
  public static taxGroupsUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<TaxGroupsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TaxGroupsUpsertResponse,
      TaxGroupsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-groups",
    });
  }

  /**
   * 🔒 Tax Groups - Get
   * [Operation: taxGroupsDetails]
   */
  public static taxGroupsDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TaxGroupsDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      TaxGroupsDetailsResponse,
      TaxGroupsDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-groups/{id}",
    });
  }

  /**
   * 🔒 Tax Groups - Set default
   * [Operation: taxGroupsSetDefault]
   */
  public static taxGroupsSetDefault<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TaxGroupsSetDefaultData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TaxGroupsSetDefaultResponse,
      TaxGroupsSetDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-groups/{id}/set-default",
    });
  }

  /**
   * 🔒 Tax Items - List
   * [Operation: taxItemsList]
   */
  public static taxItemsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      TaxItemsListResponse,
      TaxItemsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-items",
    });
  }

  /**
   * 🔒 Tax Items - Upsert
   * [Operation: taxItemsUpsert]
   */
  public static taxItemsUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<TaxItemsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TaxItemsUpsertResponse,
      TaxItemsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-items",
    });
  }

  /**
   * 🔒 Tax Items - Delete
   * [Operation: taxItemsDelete]
   */
  public static taxItemsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TaxItemsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      TaxItemsDeleteResponse,
      TaxItemsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-items/{id}",
    });
  }

  /**
   * 🔒 Tax Types - List
   * [Operation: taxTypesList]
   */
  public static taxTypesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      TaxTypesListResponse,
      TaxTypesListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-types",
    });
  }

  /**
   * 🔒 Tax types - Upsert
   * [Operation: taxTypeUpsert]
   */
  public static taxTypeUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<TaxTypeUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TaxTypeUpsertResponse,
      TaxTypeUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-types",
    });
  }

  /**
   * 🔒 Tax types - Delete
   * [Operation: taxTypeDelete]
   */
  public static taxTypeDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TaxTypeDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      TaxTypeDeleteResponse,
      TaxTypeDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-types/{id}",
    });
  }

  /**
   * 🔒 Tax types - Set default
   * [Operation: taxTypeSetDefault]
   */
  public static taxTypeSetDefault<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TaxTypeSetDefaultData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TaxTypeSetDefaultResponse,
      TaxTypeSetDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/taxes/tax-types/{id}/set-default",
    });
  }

  /**
   * 🔒  [ADM201] Users - List active
   * [Operation: usersListActive]
   */
  public static usersListActive<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      UsersListActiveResponse,
      UsersListActiveError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/users/active",
    });
  }

  /**
   * 🔒  [ADM200] Users - Invite
   * [Operation: usersInvite]
   */
  public static usersInvite<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<UsersInviteData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      UsersInviteResponse,
      UsersInviteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/users/invite",
    });
  }

  /**
   * 🔒 Webhook Endpoints - List
   * [Operation: webhookEndpointsList]
   */
  public static webhookEndpointsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WebhookEndpointsListResponse,
      WebhookEndpointsListError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/webhooks/endpoints",
    });
  }

  /**
   * 🔒 Webhook Endpoints - Upsert
   * [Operation: webhookEndpointsUpsert]
   */
  public static webhookEndpointsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WebhookEndpointsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WebhookEndpointsUpsertResponse,
      WebhookEndpointsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/webhooks/endpoints/{id}",
    });
  }

  /**
   * 🔒 Webhook Endpoints - Delete
   * [Operation: webhookEndpointsDelete]
   */
  public static webhookEndpointsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WebhookEndpointsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      WebhookEndpointsDeleteResponse,
      WebhookEndpointsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/webhooks/endpoints/{id}",
    });
  }

  /**
   * 🔒 Webhook Endpoints - Test endpoint
   * [Operation: webhookEndpointsTest]
   */
  public static webhookEndpointsTest<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WebhookEndpointsTestData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WebhookEndpointsTestResponse,
      WebhookEndpointsTestError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/webhooks/endpoints/{id}/test",
    });
  }

  /**
   * 🔒 Webhook Subscription Types - List
   * [Operation: webhookSubscriptionTypes]
   */
  public static webhookSubscriptionTypes<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WebhookSubscriptionTypesResponse,
      WebhookSubscriptionTypesError,
      ThrowOnError
    >({
      ...options,
      url: "/administration/webhooks/endpoints/types",
    });
  }
}

export class AppIntegrationService {
  /**
   * 🔒 Amazon Inbound Plans - Create
   * [Operation: amazonInboundPlansCreate]
   */
  public static amazonInboundPlansCreate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AmazonInboundPlansCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlansCreateResponse2,
      AmazonInboundPlansCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/create",
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - List
   * [Operation: amazonInboundPlansList]
   */
  public static amazonInboundPlansList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AmazonInboundPlansListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AmazonInboundPlansListResponse,
      AmazonInboundPlansListError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/list",
      responseTransformer: AmazonInboundPlansListResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Plan details
   * [Operation: amazonInboundPlansDetails]
   */
  public static amazonInboundPlansDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AmazonInboundPlansDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AmazonInboundPlansDetailsResponse,
      AmazonInboundPlansDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}",
      responseTransformer: AmazonInboundPlansDetailsResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Cancel plan
   * [Operation: amazonInboundPlansCancel]
   */
  public static amazonInboundPlansCancel<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AmazonInboundPlansCancelData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      AmazonInboundPlansCancelResponse,
      AmazonInboundPlansCancelError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/cancel",
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Holding transactions - Create
   * [Operation: amazonInboundPlansHoldingTrnsCreate]
   */
  public static amazonInboundPlansHoldingTrnsCreate<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlansHoldingTrnsCreateData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlansHoldingTrnsCreateResponse,
      AmazonInboundPlansHoldingTrnsCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/holding-trn/create",
      responseTransformer:
        AmazonInboundPlansHoldingTrnsCreateResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Packing Options Confirm
   * [Operation: amazonInboundPlansPackingOptionsConfirm]
   */
  public static amazonInboundPlansPackingOptionsConfirm<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlansPackingOptionsConfirmData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlansPackingOptionsConfirmResponse,
      AmazonInboundPlansPackingOptionsConfirmError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/packing-options/confirm",
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Packing Options List
   * [Operation: amazonInboundPlansPackingOptionsList]
   */
  public static amazonInboundPlansPackingOptionsList<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlansPackingOptionsListData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      AmazonInboundPlansPackingOptionsListResponse,
      AmazonInboundPlansPackingOptionsListError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/packing-options/list",
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Placement Options - Confirm
   * [Operation: amazonInboundPlansPlacementOptionsConfirm]
   */
  public static amazonInboundPlansPlacementOptionsConfirm<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlansPlacementOptionsConfirmData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlansPlacementOptionsConfirmResponse,
      AmazonInboundPlansPlacementOptionsConfirmError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/placement-options/confirm",
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Rename plan
   * [Operation: amazonInboundPlansRename]
   */
  public static amazonInboundPlansRename<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AmazonInboundPlansRenameData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlansRenameResponse,
      AmazonInboundPlansRenameError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/rename",
    });
  }

  /**
   * 🔒 Amazon Inbound Plans - Submit Packing Information
   * [Operation: amazonInboundPlansSubmitPackingInformation]
   */
  public static amazonInboundPlansSubmitPackingInformation<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlansSubmitPackingInformationData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlansSubmitPackingInformationResponse,
      AmazonInboundPlansSubmitPackingInformationError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-inbound-plans/{mpId}/plan/{planId}/submit-package-info",
    });
  }

  /**
   * 🔒  [APPASF001] Amazon Seller Flex - Import Shipment
   * [Operation: amazonSellerFlexImportShipment]
   */
  public static amazonSellerFlexImportShipment<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonSellerFlexImportShipmentData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonSellerFlexImportShipmentResponse,
      AmazonSellerFlexImportShipmentError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-seller-flex/{appId}/import/{shipmentId}",
    });
  }

  /**
   * 🔒 Amazon Seller Flex - Orders Map
   * [Operation: amazonSellerFlexOrdersMap]
   */
  public static amazonSellerFlexOrdersMap<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AmazonSellerFlexOrdersMapData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AmazonSellerFlexOrdersMapResponse,
      AmazonSellerFlexOrdersMapError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-seller-flex/{appId}/orders-map",
      responseTransformer: AmazonSellerFlexOrdersMapResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon Seller Flex - Process Packages
   * [Operation: amazonSellerFlexProcessPackages]
   */
  public static amazonSellerFlexProcessPackages<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonSellerFlexProcessPackagesData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonSellerFlexProcessPackagesResponse,
      AmazonSellerFlexProcessPackagesError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-seller-flex/{appId}/packages/{soId}",
    });
  }

  /**
   * 🔒 Amazon Seller Flex - Reject Shipment
   * [Operation: amazonSellerFlexRejectShipment]
   */
  public static amazonSellerFlexRejectShipment<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonSellerFlexRejectShipmentData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonSellerFlexRejectShipmentResponse,
      AmazonSellerFlexRejectShipmentError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/amazon-seller-flex/{appId}/reject/{shipmentId}",
    });
  }

  /**
   * 🔒 Apps - List
   * [Operation: appsList]
   */
  public static appsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AppsListResponse,
      AppsListError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/apps",
    });
  }

  /**
   * 🔒 Apps - Get
   * [Operation: appsGet]
   */
  public static appsGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AppsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AppsGetResponse,
      AppsGetError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/apps/{id}",
    });
  }

  /**
   * 🔒 Apps - Upsert
   * [Operation: appsUpsert]
   */
  public static appsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AppsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AppsUpsertResponse,
      AppsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/apps/{id}",
    });
  }

  /**
   * 🔒 Apps - Delete
   * [Operation: appsDelete]
   */
  public static appsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AppsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      AppsDeleteResponse,
      AppsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/apps/{id}",
    });
  }

  /**
   * 🔒 Apps - Configurations
   * [Operation: appsConfiguration]
   */
  public static appsConfiguration<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AppsConfigurationResponse,
      AppsConfigurationError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/apps/configurations",
      responseTransformer: AppsConfigurationResponseTransformer,
    });
  }

  /**
   * 🔒 Carrier - List
   * [Operation: carriersList]
   */
  public static carriersList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CarriersListResponse,
      CarriersListError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/carriers",
    });
  }

  /**
   * 🔒 Carrier - Upsert
   * [Operation: carriersUpsert]
   */
  public static carriersUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CarriersUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CarriersUpsertResponse,
      CarriersUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/carriers/{carrierId}",
    });
  }

  /**
   * 🔒 Carrier - Delete
   * [Operation: carriersDelete]
   */
  public static carriersDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CarriersDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      CarriersDeleteResponse,
      CarriersDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/carriers/{carrierId}",
    });
  }

  /**
   * 🔒 Carrier - Get
   * [Operation: carriersGet]
   */
  public static carriersGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CarriersGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CarriersGetResponse,
      CarriersGetError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/carriers/{id}",
    });
  }

  /**
   * 🔒 Carriers - Configurations
   * [Operation: carriersConfiguration]
   */
  public static carriersConfiguration<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CarriersConfigurationResponse,
      CarriersConfigurationError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/carriers/configurations",
      responseTransformer: CarriersConfigurationResponseTransformer,
    });
  }

  /**
   * 🔒 Carrier - Services
   * [Operation: carriersServices]
   */
  public static carriersServices<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CarriersServicesData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CarriersServicesResponse,
      CarriersServicesError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/carriers/services",
    });
  }

  /**
   * 🔒  [APP3PL003] Configurable 3PL - Upsert
   * [Operation: configurable3plUpsert]
   */
  public static configurable3PlUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<Configurable3PlUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      Configurable3PlUpsertResponse,
      Configurable3PlUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/configurable-3pl/{appId}",
    });
  }

  /**
   * 🔒  [APP3PL001] Configurable 3PL - Configuration
   * [Operation: configurable3plConfiguration]
   */
  public static configurable3PlConfiguration<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      Configurable3PlConfigurationResponse,
      Configurable3PlConfigurationError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/configurable-3pl/configuration",
      responseTransformer: Configurable3PlConfigurationResponseTransformer,
    });
  }

  /**
   * 🔒 Integration - Dictionary
   * [Operation: integrationDictionary]
   */
  public static integrationDictionary<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<IntegrationDictionaryData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      IntegrationDictionaryResponse,
      IntegrationDictionaryError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/dictionary/{type}/{name}",
    });
  }

  /**
   * 🔒 Marketplaces - List
   * [Operation: marketplacesListAll]
   */
  public static marketplacesListAll<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplacesListAllResponse,
      MarketplacesListAllError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces",
      responseTransformer: MarketplacesListAllResponseTransformer,
    });
  }

  /**
   * 🔒 Marketplaces - Get
   * [Operation: marketplacesGet]
   */
  public static marketplacesGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplacesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplacesGetResponse,
      MarketplacesGetError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}",
      responseTransformer: MarketplacesGetResponseTransformer,
    });
  }

  /**
   * 🔒 Marketplaces - Upsert
   * [Operation: marketplacesUpsert]
   */
  public static marketplacesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplacesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MarketplacesUpsertResponse,
      MarketplacesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}",
    });
  }

  /**
   * 🔒 Marketplaces - Delete
   * [Operation: marketplaceDelete]
   */
  public static marketplaceDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplaceDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      MarketplaceDeleteResponse,
      MarketplaceDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}",
    });
  }

  /**
   * 🔒 Marketplaces - Listed Items
   * [Operation: marketplaceListedItems]
   */
  public static marketplaceListedItems<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplaceListedItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplaceListedItemsResponse,
      MarketplaceListedItemsError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}/listed-items",
      responseTransformer: MarketplaceListedItemsResponseTransformer,
    });
  }

  /**
   * 🔒 Marketplaces - Unlink Listed Items
   * [Operation: marketplaceListedItemsBulkUpdate]
   */
  public static marketplaceListedItemsBulkUpdate<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      MarketplaceListedItemsBulkUpdateData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      MarketplaceListedItemsBulkUpdateResponse,
      MarketplaceListedItemsBulkUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}/listed-items/bulk-update",
    });
  }

  /**
   * 🔒 Marketplaces - Export Listed Items
   * [Operation: marketplaceListedItemsExport]
   */
  public static marketplaceListedItemsExport<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<MarketplaceListedItemsExportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MarketplaceListedItemsExportResponse,
      MarketplaceListedItemsExportError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}/listed-items/export",
    });
  }

  /**
   * 🔒 Marketplaces - Listed Items - Import
   * [Operation: marketplaceListedItemsImport]
   */
  public static marketplaceListedItemsImport<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<MarketplaceListedItemsImportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MarketplaceListedItemsImportResponse,
      MarketplaceListedItemsImportError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}/listed-items/import",
    });
  }

  /**
   * 🔒 Marketplaces - Listed Items Summary
   * [Operation: marketplaceListedItemsSummary]
   */
  public static marketplaceListedItemsSummary<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      MarketplaceListedItemsSummaryData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      MarketplaceListedItemsSummaryResponse,
      MarketplaceListedItemsSummaryError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}/listed-items/summary",
      responseTransformer: MarketplaceListedItemsSummaryResponseTransformer,
    });
  }

  /**
   * 🔒 Marketplaces - Update Listed Items
   * [Operation: marketplaceListedItemsUpdate]
   */
  public static marketplaceListedItemsUpdate<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<MarketplaceListedItemsUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MarketplaceListedItemsUpdateResponse,
      MarketplaceListedItemsUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/{id}/listed-items/update",
    });
  }

  /**
   * 🔒 Marketplaces - Configurations
   * [Operation: marketplacesConfiguration]
   */
  public static marketplacesConfiguration<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplacesConfigurationResponse,
      MarketplacesConfigurationError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/configurations",
      responseTransformer: MarketplacesConfigurationResponseTransformer,
    });
  }

  /**
   * 🔒 Marketplaces - List Groups
   * [Operation: marketplacesGroups]
   */
  public static marketplacesGroups<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplacesGroupsResponse,
      MarketplacesGroupsError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/groups",
    });
  }

  /**
   * 🔒 Marketplaces - Get Group Configuration
   * [Operation: marketplacesGroup]
   */
  public static marketplacesGroup<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplacesGroupData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplacesGroupResponse,
      MarketplacesGroupError,
      ThrowOnError
    >({
      ...options,
      url: "/integration/marketplaces/groups/{id}",
    });
  }
}

export class AuthenticationService {
  /**
   * 🔓  [AUTH09] Process Invite link
   */
  public static postAuthenticationInviteProcess<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationInviteProcessData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationInviteProcessResponse,
      PostAuthenticationInviteProcessError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/invite-process",
    });
  }

  /**
   * 🔓  [AUTH06] Get Invite link status
   */
  public static postAuthenticationInviteStatus<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationInviteStatusData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationInviteStatusResponse,
      PostAuthenticationInviteStatusError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/invite-status",
    });
  }

  /**
   * 🔓  [AUTH01] Login email authentication
   */
  public static postAuthenticationLoginEmail<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationLoginEmailData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationLoginEmailResponse,
      PostAuthenticationLoginEmailError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/login/email",
    });
  }

  /**
   * 🔓  [AUTH04] Login MFA authentication
   */
  public static postAuthenticationLoginMfa<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<PostAuthenticationLoginMfaData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationLoginMfaResponse,
      PostAuthenticationLoginMfaError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/login/mfa",
    });
  }

  /**
   * 🔓  [AUTH03] Login MFA - Notify method
   */
  public static postAuthenticationLoginMfaNotify<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationLoginMfaNotifyData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationLoginMfaNotifyResponse,
      PostAuthenticationLoginMfaNotifyError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/login/mfa/notify",
    });
  }

  /**
   * 🔓  [AUTH02] Login password authentication
   */
  public static postAuthenticationLoginPassword<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationLoginPasswordData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationLoginPasswordResponse,
      PostAuthenticationLoginPasswordError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/login/password",
    });
  }

  /**
   *  [AUTH00] Logout
   */
  public static postAuthenticationLogout<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationLogoutResponse,
      PostAuthenticationLogoutError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/logout",
    });
  }

  /**
   * 🔓  [AUTH07] Login Oauth authentication
   */
  public static postAuthenticationOauth<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PostAuthenticationOauthData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationOauthResponse,
      PostAuthenticationOauthError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/oauth",
    });
  }

  /**
   * 🔓  [AUTH10] Password reset request
   */
  public static postAuthenticationPasswordResetRequest<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationPasswordResetRequestData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationPasswordResetRequestResponse,
      PostAuthenticationPasswordResetRequestError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/password-reset-request",
    });
  }

  /**
   * 🔓  [AUTH05] Password reset response
   */
  public static postAuthenticationPasswordResetResponse<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationPasswordResetResponseData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationPasswordResetResponseResponse,
      PostAuthenticationPasswordResetResponseError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/password-reset-response",
    });
  }

  /**
   *  [PRF19] Profile - User Profile
   */
  public static getAuthenticationProfile<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetAuthenticationProfileResponse,
      GetAuthenticationProfileError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile",
    });
  }

  /**
   *  [PRF11] Profile Update
   */
  public static postAuthenticationProfile<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PostAuthenticationProfileData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationProfileResponse,
      PostAuthenticationProfileError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile",
    });
  }

  /**
   *  [PRF03] MFA - List Methods
   */
  public static getAuthenticationProfileMfaMethods<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetAuthenticationProfileMfaMethodsResponse,
      GetAuthenticationProfileMfaMethodsError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/methods",
    });
  }

  /**
   *  [PRF07] Mfa Method - Delete
   */
  public static deleteAuthenticationProfileMfaMethodsId<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      DeleteAuthenticationProfileMfaMethodsIdData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).delete<
      DeleteAuthenticationProfileMfaMethodsIdResponse,
      DeleteAuthenticationProfileMfaMethodsIdError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/methods/{id}",
    });
  }

  /**
   *  [PRF06] Mfa Method - Set Primary
   */
  public static putAuthenticationProfileMfaMethodsIdDefault<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      PutAuthenticationProfileMfaMethodsIdDefaultData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).put<
      PutAuthenticationProfileMfaMethodsIdDefaultResponse,
      PutAuthenticationProfileMfaMethodsIdDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/methods/{id}/default",
    });
  }

  /**
   *  [PRF09] MFA - Setup Request
   */
  public static postAuthenticationProfileMfaSetup<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationProfileMfaSetupData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationProfileMfaSetupResponse,
      PostAuthenticationProfileMfaSetupError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/setup",
    });
  }

  /**
   *  [PRF05] MFA - Setup Confirm
   */
  public static postAuthenticationProfileMfaSetupConfirm<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationProfileMfaSetupConfirmData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationProfileMfaSetupConfirmResponse,
      PostAuthenticationProfileMfaSetupConfirmError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/setup/confirm",
    });
  }

  /**
   *  [PRF01] MFA Trusted Devices - List
   */
  public static getAuthenticationProfileMfaTrustedDevices<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      GetAuthenticationProfileMfaTrustedDevicesData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetAuthenticationProfileMfaTrustedDevicesResponse,
      GetAuthenticationProfileMfaTrustedDevicesError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/trusted-devices",
      responseTransformer:
        GetAuthenticationProfileMfaTrustedDevicesResponseTransformer,
    });
  }

  /**
   *  [PRF02] MFA Trusted Devices - Delete
   */
  public static deleteAuthenticationProfileMfaTrustedDevicesDeviceid<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      DeleteAuthenticationProfileMfaTrustedDevicesDeviceidData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).delete<
      DeleteAuthenticationProfileMfaTrustedDevicesDeviceidResponse,
      DeleteAuthenticationProfileMfaTrustedDevicesDeviceidError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/mfa/trusted-devices/{deviceId}",
    });
  }

  /**
   *  [PRF10] Update Password
   */
  public static postAuthenticationProfilePasswordUpdate<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      PostAuthenticationProfilePasswordUpdateData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationProfilePasswordUpdateResponse,
      PostAuthenticationProfilePasswordUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/profile/password-update",
    });
  }

  /**
   *  [AUTH08] Token authentication
   */
  public static postAuthenticationToken<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PostAuthenticationTokenData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostAuthenticationTokenResponse,
      PostAuthenticationTokenError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication/token",
    });
  }
}

export class AuthenticationCenterService {
  /**
   * 🔓 Creates a new session for the user.
   * [Operation: loginCreate]
   */
  public static loginCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<LoginCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      LoginCreateResponse,
      LoginCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/authentication-center/login",
    });
  }
}

export class ContactsService {
  /**
   * 🔒  [CON06] List contact address
   * [Operation: contactAddressList]
   */
  public static contactAddressList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactAddressListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ContactAddressListResponse,
      ContactAddressListError,
      ThrowOnError
    >({
      ...options,
      url: "/contacts/{contactCode}/address",
    });
  }

  /**
   * 🔒  [CON08] Contacts lookup
   * [Operation: contactsLookup]
   */
  public static contactsLookup<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactsLookupData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ContactsLookupResponse,
      ContactsLookupError,
      ThrowOnError
    >({
      ...options,
      url: "/contacts/lookup",
    });
  }

  /**
   * 🔒 Contact tags - list
   * [Operation: contactTagsList]
   */
  public static contactTagsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ContactTagsListResponse,
      ContactTagsListError,
      ThrowOnError
    >({
      ...options,
      url: "/contacts/tags-list",
    });
  }

  /**
   * 🔒 Contact tags list - upsert
   * [Operation: contactTagsListUpsert]
   */
  public static contactTagsListUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactTagsListUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ContactTagsListUpsertResponse,
      ContactTagsListUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/contacts/tags-list/{id}",
    });
  }

  /**
   * 🔒 Contact tags - delete
   * [Operation: contactTagsListDelete]
   */
  public static contactTagsListDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactTagsListDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ContactTagsListDeleteResponse,
      ContactTagsListDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/contacts/tags-list/{id}",
    });
  }

  /**
   * 🔒  [CON13] Contact tags - bulk operation
   * [Operation: contactTagsListBulkOperation]
   */
  public static contactTagsListBulkOperation<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      ContactTagsListBulkOperationData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      ContactTagsListBulkOperationResponse,
      ContactTagsListBulkOperationError,
      ThrowOnError
    >({
      ...options,
      url: "/contacts/tags-list/bulk",
    });
  }
}

export class ContactsV1Service {
  /**
   * 🔒 Create contact
   * [Operation: contactCreate]
   */
  public static contactCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ContactCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ContactCreateResponse,
      ContactCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/contacts/create",
    });
  }

  /**
   * 🔒 Contact details
   * [Operation: contactEntity]
   */
  public static contactEntity<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactEntityData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ContactEntityResponse,
      ContactEntityError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/contacts/details/{id}",
      responseTransformer: ContactEntityResponseTransformer,
    });
  }

  /**
   * 🔒 Contact details by code
   * [Operation: contactEntityByCode]
   */
  public static contactEntityByCode<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactEntityByCodeData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ContactEntityByCodeResponse,
      ContactEntityByCodeError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/contacts/details/code/{code}",
      responseTransformer: ContactEntityByCodeResponseTransformer,
    });
  }

  /**
   * 🔒 Contact list - search
   * [Operation: contactsList]
   */
  public static contactsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ContactsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ContactsListResponse,
      ContactsListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/contacts/list",
    });
  }

  /**
   * 🔒 Contact update
   * [Operation: contactUpdate]
   */
  public static contactUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ContactUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      ContactUpdateResponse,
      ContactUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/contacts/update/{id}",
    });
  }
}

export class DevicesService {
  /**
   * 🔓
   * [Operation: appUpdateCheck]
   */
  public static appUpdateCheck<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<AppUpdateCheckData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AppUpdateCheckResponse,
      AppUpdateCheckError,
      ThrowOnError
    >({
      ...options,
      url: "/devices/app-update/{appId}",
    });
  }

  /**
   * 🔓  [ADPS09] Get Print Station Configuration
   */
  public static getDevicesPrintStation<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<GetDevicesPrintStationData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetDevicesPrintStationResponse,
      GetDevicesPrintStationError,
      ThrowOnError
    >({
      ...options,
      url: "/devices/print-station",
    });
  }

  /**
   * 🔓  [ADPS10] Save Print Station Mapping
   */
  public static postDevicesPrintStationMapping<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      PostDevicesPrintStationMappingData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostDevicesPrintStationMappingResponse,
      PostDevicesPrintStationMappingError,
      ThrowOnError
    >({
      ...options,
      url: "/devices/print-station/mapping",
    });
  }
}

export class DocumentsService {
  /**
   * 🔒  [DOC04] Document attachments - List
   * [Operation: documentAttachmentsList]
   */
  public static documentAttachmentsList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentAttachmentsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentAttachmentsListResponse,
      DocumentAttachmentsListError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/attachments/{documentType}/{documentId}",
      responseTransformer: DocumentAttachmentsListResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC05] Document attachment - Create
   * [Operation: documentAttachmentsCreate]
   */
  public static documentAttachmentsCreate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentAttachmentsCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentAttachmentsCreateResponse,
      DocumentAttachmentsCreateError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/documents/attachments/{documentType}/{documentId}",
    });
  }

  /**
   * 🔒  [DOC05A] Document attachment - Create (scan-to-cloud)
   * [Operation: scanToCloudUpload]
   */
  public static scanToCloudUpload<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ScanToCloudUploadData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ScanToCloudUploadResponse,
      ScanToCloudUploadError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/documents/attachments/scan-to-cloud",
    });
  }

  /**
   * 🔒  [DOC22] Bulk insert
   * [Operation: bulkInsert]
   */
  public static bulkInsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<BulkInsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      BulkInsertResponse,
      BulkInsertError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/bulk-insert/{documentType}/{documentId}",
    });
  }

  /**
   * 🔒  [DOC32] Export monitor - List
   * [Operation: dataExportMonitorList]
   */
  public static dataExportMonitorList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<DataExportMonitorListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DataExportMonitorListResponse,
      DataExportMonitorListError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/data-exports",
      responseTransformer: DataExportMonitorListResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC01] Retrieve document details
   * [Operation: documentDetails]
   */
  public static documentDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentDetailsResponse,
      DocumentDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/details/{documentType}/{documentId}",
    });
  }

  /**
   * 🔒  [DOC09] Export pending - Update
   * [Operation: exportPendingUpdate]
   */
  public static exportPendingUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ExportPendingUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ExportPendingUpdateResponse,
      ExportPendingUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/export/{documentType}/{documentId}",
    });
  }

  /**
   * 🔒  [DOC03] Export pending - List
   * [Operation: exportPendingList]
   */
  public static exportPendingList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ExportPendingListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ExportPendingListResponse,
      ExportPendingListError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/export/pending/{headerId}",
    });
  }

  /**
   * 🔒  [DOC23] Document Item lookup
   * [Operation: itemSearch]
   */
  public static itemSearch<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemSearchData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemSearchResponse,
      ItemSearchError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/item-lookup/{documentType}",
    });
  }

  /**
   * 🔒  [DOC24] Document Item price lookup
   * [Operation: itemPriceLookup]
   */
  public static itemPriceLookup<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemPriceLookupData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemPriceLookupResponse,
      ItemPriceLookupError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/item-price/{documentType}/{itemId}",
    });
  }

  /**
   * 🔒 Matched Document AI - Details
   * [Operation: matchedDocumentAiDetails]
   */
  public static matchedDocumentAiDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MatchedDocumentAiDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MatchedDocumentAiDetailsResponse,
      MatchedDocumentAiDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/matched-document-ai/{documentId}",
      responseTransformer: MatchedDocumentAiDetailsResponseTransformer,
    });
  }

  /**
   * 🔒 Matched Document AI - Accept
   * [Operation: matchedDocumentAiAccept]
   */
  public static matchedDocumentAiAccept<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MatchedDocumentAiAcceptData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MatchedDocumentAiAcceptResponse,
      MatchedDocumentAiAcceptError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/matched-document-ai/{documentId}/accept",
    });
  }

  /**
   * 🔒 Matched Document AI - Confirm contact
   * [Operation: matchedDocumentAiConfirmContact]
   */
  public static matchedDocumentAiConfirmContact<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      MatchedDocumentAiConfirmContactData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      MatchedDocumentAiConfirmContactResponse,
      MatchedDocumentAiConfirmContactError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/matched-document-ai/{documentId}/confirm-contact",
      responseTransformer: MatchedDocumentAiConfirmContactResponseTransformer,
    });
  }

  /**
   * 🔒 Matched Document AI - Create
   * [Operation: matchedDocumentAiCreate]
   */
  public static matchedDocumentAiCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<MatchedDocumentAiCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MatchedDocumentAiCreateResponse,
      MatchedDocumentAiCreateError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/documents/matched-document-ai/create",
      responseTransformer: MatchedDocumentAiCreateResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC06] Document notes - List
   * [Operation: documentNotesList]
   */
  public static documentNotesList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentNotesListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentNotesListResponse,
      DocumentNotesListError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/notes/{documentType}/{documentId}",
      responseTransformer: DocumentNotesListResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC07] Document notes - Append
   * [Operation: documentNotesAppend]
   */
  public static documentNotesAppend<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentNotesAppendData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentNotesAppendResponse,
      DocumentNotesAppendError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/notes/{documentType}/{documentId}",
      responseTransformer: DocumentNotesAppendResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC08] Document notes - delete
   * [Operation: documentNotesDelete]
   */
  public static documentNotesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentNotesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DocumentNotesDeleteResponse,
      DocumentNotesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/notes/{noteId}",
    });
  }

  /**
   * 🔒  [DOC11]
   * [Operation: postcodeLookup]
   */
  public static postcodeLookup<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PostcodeLookupData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostcodeLookupResponse,
      PostcodeLookupError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/postcode-lookup",
    });
  }

  /**
   * 🔒  [DOC30] Document queues
   * [Operation: documentQueues]
   */
  public static documentQueues<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentQueuesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentQueuesResponse,
      DocumentQueuesError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/queues/{documentType}",
      responseTransformer: DocumentQueuesResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC02] Document search
   * [Operation:  DocumentsSearch]
   */
  public static documentsSearch<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentsSearchData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DocumentsSearchResponse,
      DocumentsSearchError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/search",
      responseTransformer: DocumentsSearchResponseTransformer,
    });
  }

  /**
   * 🔒  [DOC20] Retrieve storage object
   */
  public static getDocumentsStorageKey<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<GetDocumentsStorageKeyData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<void, unknown, ThrowOnError>({
      ...options,
      url: "/documents/storage/{key}",
    });
  }

  /**
   * 🔒  [DOC21] Save storage object
   */
  public static postDocumentsStorageKey<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PostDocumentsStorageKeyData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<void, unknown, ThrowOnError>({
      ...options,
      url: "/documents/storage/{key}",
    });
  }

  /**
   * 🔒  [DOC31] Document tags update
   * [Operation: documentTagsUpdate]
   */
  public static documentTagsUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DocumentTagsUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DocumentTagsUpdateResponse,
      DocumentTagsUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/documents/tags/{documentType}/{documentId}",
    });
  }
}

export class InboundService {
  /**
   * 🔒  [INB07] List Inbound ASN documents
   */
  public static getInboundDocumentAsn<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<GetInboundDocumentAsnData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetInboundDocumentAsnResponse,
      GetInboundDocumentAsnError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/document/asn",
      responseTransformer: GetInboundDocumentAsnResponseTransformer,
    });
  }

  /**
   * 🔒  [INB60] PO - Get Document
   * [Operation: purchaseOrderGet]
   */
  public static purchaseOrderGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PurchaseOrderGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PurchaseOrderGetResponse,
      PurchaseOrderGetError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/document/po/{documentId}",
      responseTransformer: PurchaseOrderGetResponseTransformer,
    });
  }

  /**
   * 🔒  [INB21] List PO documents
   * [Operation: poList]
   */
  public static poList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PoListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PoListResponse,
      PoListError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/document/po/search",
      responseTransformer: PoListResponseTransformer,
    });
  }

  /**
   * 🔒  [INB08] List Inbound shipment documents
   */
  public static getInboundDocumentShpSearch<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<GetInboundDocumentShpSearchData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetInboundDocumentShpSearchResponse,
      GetInboundDocumentShpSearchError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/document/shp/search",
      responseTransformer: GetInboundDocumentShpSearchResponseTransformer,
    });
  }

  /**
   *  [INB101] PO -> Items Mapping
   * [Operation: itemsMapping]
   */
  public static itemsMapping<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemsMappingData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemsMappingResponse2,
      ItemsMappingError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/items-mapping",
      responseTransformer: ItemsMappingResponseTransformer,
    });
  }

  /**
   *  [INB04] List all pending inbound documents
   */
  public static getInboundPending<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetInboundPendingResponse,
      GetInboundPendingError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/pending",
      responseTransformer: GetInboundPendingResponseTransformer,
    });
  }

  /**
   *  [INB59] Create a PO Document
   * [Operation: createPurchaseOrder]
   */
  public static createPurchaseOrder<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CreatePurchaseOrderData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreatePurchaseOrderResponse,
      CreatePurchaseOrderError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/po/create",
    });
  }

  /**
   *  [INB59B] Create a PO Document [Bulk]
   * [Operation: createPurchaseOrders]
   */
  public static createPurchaseOrders<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CreatePurchaseOrdersData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreatePurchaseOrdersResponse,
      CreatePurchaseOrdersError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/po/create-bulk",
    });
  }

  /**
   *  [INB97] RCT - List for linked document
   * [Operation: rctDocumentLinked]
   */
  public static rctDocumentLinked<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<RctDocumentLinkedData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      RctDocumentLinkedResponse,
      RctDocumentLinkedError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/rct/linked/{documentType}/{documentId}",
      responseTransformer: RctDocumentLinkedResponseTransformer,
    });
  }

  /**
   *  [INB16] Receive with document identification
   * [Operation: receive]
   */
  public static receive<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ReceiveData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ReceiveResponse2,
      ReceiveError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/receive",
    });
  }

  /**
   *  [INB06] Receive inventory to warehouse
   * [Operation: receiveByDocument]
   */
  public static receiveByDocument<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ReceiveByDocumentData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ReceiveByDocumentResponse,
      ReceiveByDocumentError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/receive/{documentType}/{documentId}",
    });
  }

  /**
   *  [INB99] Inbound document - Get
   * [Operation: inboundDocumentGet]
   */
  public static inboundDocumentGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<InboundDocumentGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      InboundDocumentGetResponse,
      InboundDocumentGetError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/receiving/{documentType}/{documentId}",
      responseTransformer: InboundDocumentGetResponseTransformer,
    });
  }

  /**
   *  [INB98] Inbound document - Create
   * [Operation: inboundDocumentCreate]
   */
  public static inboundDocumentCreate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<InboundDocumentCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InboundDocumentCreateResponse,
      InboundDocumentCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/inbound/receiving/{documentType}/{documentId}",
    });
  }
}

export class InventoryService {
  /**
   * Assembly - Create
   */
  public static postInventoryAssemblyCreate<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<PostInventoryAssemblyCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostInventoryAssemblyCreateResponse,
      PostInventoryAssemblyCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/assembly/create",
      responseTransformer: PostInventoryAssemblyCreateResponseTransformer,
    });
  }

  /**
   * Assembly - Prep Info
   */
  public static postInventoryAssemblyPrep<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PostInventoryAssemblyPrepData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PostInventoryAssemblyPrepResponse,
      PostInventoryAssemblyPrepError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/assembly/prep",
      responseTransformer: PostInventoryAssemblyPrepResponseTransformer,
    });
  }

  /**
   * Assembly - Work Orders List
   */
  public static getInventoryAssemblyWorkOrders<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      GetInventoryAssemblyWorkOrdersData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetInventoryAssemblyWorkOrdersResponse,
      GetInventoryAssemblyWorkOrdersError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/assembly/work-orders",
      responseTransformer: GetInventoryAssemblyWorkOrdersResponseTransformer,
    });
  }

  /**
   * Assembly - Work Order Details
   */
  public static getInventoryAssemblyWorkOrdersId<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      GetInventoryAssemblyWorkOrdersIdData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetInventoryAssemblyWorkOrdersIdResponse,
      GetInventoryAssemblyWorkOrdersIdError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/assembly/work-orders/{id}",
      responseTransformer: GetInventoryAssemblyWorkOrdersIdResponseTransformer,
    });
  }

  /**
   * 🔒 Bin content
   * [Operation: binContent]
   */
  public static binContent<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<BinContentData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      BinContentResponse,
      BinContentError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/bin-content/{binName}",
      responseTransformer: BinContentResponseTransformer,
    });
  }

  /**
   * 🔒  [INVEX83] Catalog items export
   * [Operation: catalogItemsExport]
   */
  public static catalogItemsExport<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CatalogItemsExportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CatalogItemsExportResponse,
      CatalogItemsExportError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/catalog/{id}/export",
    });
  }

  /**
   * 🔒 Catalog items import
   * [Operation: itemCatalogBulkImport]
   */
  public static itemCatalogBulkImport<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemCatalogBulkImportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemCatalogBulkImportResponse,
      ItemCatalogBulkImportError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/catalog/{id}/import",
    });
  }

  /**
   * 🔒  [INV15] List item divisions
   */
  public static getInventoryDivisions<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<void, unknown, ThrowOnError>({
      ...options,
      url: "/inventory/divisions",
    });
  }

  /**
   * 🔒 Item identifier - Next Ean
   * [Operation: itemIdentifierNextEan]
   */
  public static itemIdentifierNextEan<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemIdentifierNextEanResponse,
      ItemIdentifierNextEanError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item-identifiers/next-ean",
    });
  }

  /**
   * 🔒 Items labels - List for document
   * [Operation: itemLabelsDocumentList]
   */
  public static itemLabelsDocumentList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemLabelsDocumentListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemLabelsDocumentListResponse,
      ItemLabelsDocumentListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item-labels/{documentType}/{documentId}",
      responseTransformer: ItemLabelsDocumentListResponseTransformer,
    });
  }

  /**
   *  [INV25] Items labels - Print
   * [Operation: itemLabelsPrintBulk]
   */
  public static itemLabelsPrintBulk<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemLabelsPrintBulkData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemLabelsPrintBulkResponse,
      ItemLabelsPrintBulkError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item-labels/print",
    });
  }

  /**
   * 🔒 Items labels - Print for document
   * [Operation: itemLabelsDocumentPrint]
   */
  public static itemLabelsDocumentPrint<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemLabelsDocumentPrintData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemLabelsDocumentPrintResponse,
      ItemLabelsDocumentPrintError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item-labels/print/{documentType}/{documentId}",
    });
  }

  /**
   * 🔒  [INV32] Get item basic info
   * [Operation: itemBasicDetails]
   */
  public static itemBasicDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemBasicDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemBasicDetailsResponse,
      ItemBasicDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item-lookup/{itemSku}",
    });
  }

  /**
   * 🔒  [INV45] Item batch list
   * [Operation: itemBatches]
   */
  public static itemBatches<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemBatchesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemBatchesResponse,
      ItemBatchesError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/batches",
      responseTransformer: ItemBatchesResponseTransformer,
    });
  }

  /**
   * 🔒  [INV41] Item contact info upsert
   * [Operation: itemContactInfoUpsert]
   */
  public static itemContactInfoUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemContactInfoUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemContactInfoUpsertResponse,
      ItemContactInfoUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/contact/{contactCode}",
    });
  }

  /**
   *  [INV30] Add item identifiers
   * [Operation: itemIdentifierAppend]
   */
  public static itemIdentifierAppend<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemIdentifierAppendData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemIdentifierAppendResponse,
      ItemIdentifierAppendError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/identifier",
    });
  }

  /**
   * 🔒  [ITMIMG02] Item images - Add
   * [Operation: itemImagesAdd]
   */
  public static itemImagesAdd<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemImagesAddData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemImagesAddResponse,
      ItemImagesAddError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/images",
    });
  }

  /**
   * 🔒 Item Images - Delete
   * [Operation: itemImagesDelete]
   */
  public static itemImagesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemImagesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemImagesDeleteResponse,
      ItemImagesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/images/{imageId}",
    });
  }

  /**
   * 🔒  [ITMIMG04] Item Images - Update
   * [Operation: itemImageUpdate]
   */
  public static itemImageUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemImageUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ItemImageUpdateResponse,
      ItemImageUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/images/{imageId}",
    });
  }

  /**
   * 🔒  [INV28] item inventory summary
   * [Operation: itemInventory]
   */
  public static itemInventory<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemInventoryData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemInventoryResponse,
      ItemInventoryError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/inventory",
    });
  }

  /**
   * 🔒  [INV31] Item inventory 3rd summary
   * [Operation: itemInventory3d]
   */
  public static itemInventory3D<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemInventory3DData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemInventory3DResponse,
      ItemInventory3DError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/inventory-3d",
      responseTransformer: ItemInventory3DResponseTransformer,
    });
  }

  /**
   * 🔒  [INV29] Get item inventory log
   * [Operation: itemInventoryLog]
   */
  public static itemInventoryLog<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemInventoryLogData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemInventoryLogResponse,
      ItemInventoryLogError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/inventory-log",
      responseTransformer: ItemInventoryLogResponseTransformer,
    });
  }

  /**
   * 🔒  [INV33] Get item inventory drilldown
   * [Operation: itemInventoryDrilldown]
   */
  public static itemInventoryDrilldown<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemInventoryDrilldownData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemInventoryDrilldownResponse,
      ItemInventoryDrilldownError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/inventory/drilldown/{warehouseId}",
      responseTransformer: ItemInventoryDrilldownResponseTransformer,
    });
  }

  /**
   * 🔒  [INV13] Get item pricing
   * [Operation: itemPricing]
   */
  public static itemPricing<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemPricingData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemPricingResponse,
      ItemPricingError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/pricing",
      responseTransformer: ItemPricingResponseTransformer,
    });
  }

  /**
   * 🔒  [INV34] Get item quick-view summary
   * [Operation: itemQuickView]
   */
  public static itemQuickView<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemQuickViewData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemQuickViewResponse,
      ItemQuickViewError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/quick-view/{qvType}",
      responseTransformer: ItemQuickViewResponseTransformer,
    });
  }

  /**
   * 🔒  [INV27] Get item Uom
   * [Operation: itemUom]
   */
  public static itemUom<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemUomData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemUomResponse,
      ItemUomError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/uom",
    });
  }

  /**
   * 🔒  [INV40] Item vendor upsert
   * [Operation: itemVendorCatalogUpsert]
   */
  public static itemVendorCatalogUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemVendorCatalogUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemVendorCatalogUpsertResponse,
      ItemVendorCatalogUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/{itemSku}/vendor/{contactCode}",
    });
  }

  /**
   * 🔒 Item Images - Bulk Patch
   * [Operation: itemImagesBulkUpdate]
   */
  public static itemImagesBulkUpdate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemImagesBulkUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ItemImagesBulkUpdateResponse,
      ItemImagesBulkUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/images",
    });
  }

  /**
   * 🔒 Item images - Upload
   * Only supports multipart/form-data
   * [Operation: itemImagesDrop]
   */
  public static itemImagesDrop<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemImagesDropData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemImagesDropResponse2,
      ItemImagesDropError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/inventory/item/images/drop",
    });
  }

  /**
   * 🔒  [INV11] Item tags update
   */
  public static patchInventoryItemTags<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PatchInventoryItemTagsData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      PatchInventoryItemTagsResponse,
      PatchInventoryItemTagsError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/item/tags",
    });
  }

  /**
   * 🔒 Items List - Export
   * [Operation: itemsListExport]
   */
  public static itemsListExport<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemsListExportData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemsListExportResponse,
      ItemsListExportError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/items/export",
    });
  }

  /**
   * 🔒  [INV82] Items List - Search
   * [Operation: itemsList]
   */
  public static itemsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemsListResponse,
      ItemsListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/items/list",
    });
  }

  /**
   * 🔒  [INV82B] Items List - By Item
   * [Operation: itemsListBySkus]
   */
  public static itemsListBySkus<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemsListBySkusData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemsListBySkusResponse,
      ItemsListBySkusError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/items/list",
    });
  }

  /**
   * 🔒  [INVB34] Items bulk upsert
   * [Operation: itemsBulkUpsert]
   */
  public static itemsBulkUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemsBulkUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemsBulkUpsertResponse,
      ItemsBulkUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/items/upsert",
    });
  }

  /**
   * 🔒  [INV16] Item lookup
   * [Operation: itemLookup]
   */
  public static itemLookup<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemLookupData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemLookupResponse,
      ItemLookupError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/lookup",
    });
  }

  /**
   * 🔒  [INVB35] Pricelist Conditionals Upsert
   * [Operation: pricelistConditionalUpsert]
   */
  public static pricelistConditionalUpsert<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<PricelistConditionalUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistConditionalUpsertResponse,
      PricelistConditionalUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/price-list/upsert/conditional",
    });
  }

  /**
   * 🔒  [INVB36] Pricelist Uom Upsert
   * [Operation: pricelistUomUpsert]
   */
  public static pricelistUomUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PricelistUomUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistUomUpsertResponse,
      PricelistUomUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/price-list/upsert/uom",
    });
  }

  /**
   * 🔒 Pricelist - Purge conditionals
   * [Operation: pricelistPurgeConditionals]
   */
  public static pricelistPurgeConditionals<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<PricelistPurgeConditionalsData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PricelistPurgeConditionalsResponse,
      PricelistPurgeConditionalsError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/pricelists/{id}/conditionals/purge",
    });
  }

  /**
   * 🔒 Pricelist export
   * [Operation: pricelistExport]
   */
  public static pricelistExport<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PricelistExportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistExportResponse,
      PricelistExportError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/pricelists/{id}/export",
    });
  }

  /**
   * 🔒 Pricelist - Purge conditionals - all pricelists
   * [Operation: pricelistPurgeConditionalsAll]
   */
  public static pricelistPurgeConditionalsAll<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).patch<
      PricelistPurgeConditionalsAllResponse,
      PricelistPurgeConditionalsAllError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/pricelists/conditionals/purge",
    });
  }

  /**
   * 🔒 Pricelist export all
   * [Operation: pricelistExportAll]
   */
  public static pricelistExportAll<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PricelistExportAllData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistExportAllResponse,
      PricelistExportAllError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/pricelists/export-all",
    });
  }

  /**
   * 🔒 Pricelist Upsert
   * [Operation: pricelistEntriesUpsert]
   */
  public static pricelistEntriesUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PricelistEntriesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistEntriesUpsertResponse,
      PricelistEntriesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/pricelists/upsert/prices",
    });
  }

  /**
   *  [INV22] List stock summary of items
   * [Operation: stockSummary]
   */
  public static stockSummary<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<StockSummaryData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      StockSummaryResponse,
      StockSummaryError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/stock-summary",
      responseTransformer: StockSummaryResponseTransformer,
    });
  }

  /**
   * List detailed stock summary of items
   * Get a stock summary of items, split by batch and bin location,  Results will not include un-batched and un-binned items. Results will not include zero quantity
   * [Operation: stockSummaryDetailed]
   */
  public static stockSummaryDetailed<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<StockSummaryDetailedData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      StockSummaryDetailedResponse,
      StockSummaryDetailedError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory/stock-summary-detailed",
      responseTransformer: StockSummaryDetailedResponseTransformer,
    });
  }
}

export class InventoryAdministrationService {
  /**
   * 🔒 Item App Categories - Delete
   * [Operation: itemAppCategoriesDelete]
   */
  public static itemAppCategoriesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemAppCategoriesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemAppCategoriesDeleteResponse,
      ItemAppCategoriesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/app-categories/{id}",
    });
  }

  /**
   * 🔒 Item App Categories - Get
   * [Operation: itemAppCategoriesGet]
   */
  public static itemAppCategoriesGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemAppCategoriesGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemAppCategoriesGetResponse,
      ItemAppCategoriesGetError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/app-categories/{id}",
    });
  }

  /**
   * 🔒 Item App Categories - Upsert
   * [Operation: itemAppCategoriesUpsert]
   */
  public static itemAppCategoriesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemAppCategoriesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemAppCategoriesUpsertResponse,
      ItemAppCategoriesUpsertError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/inventory-administration/app-categories/{id}",
    });
  }

  /**
   * 🔒 Item App Categories - Sort
   * [Operation: itemAppCategoriesSorting]
   */
  public static itemAppCategoriesSorting<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemAppCategoriesSortingData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemAppCategoriesSortingResponse,
      ItemAppCategoriesSortingError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/app-categories/sort",
    });
  }

  /**
   * 🔒  [INVA202] Item Brands - Delete
   * [Operation: itemBrandsDelete]
   */
  public static itemBrandsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemBrandsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemBrandsDeleteResponse,
      ItemBrandsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/brands/{id}",
    });
  }

  /**
   * 🔒  [INVA203] Item Brands - Upsert
   * [Operation: itemBrandsUpsert]
   */
  public static itemBrandsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemBrandsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemBrandsUpsertResponse,
      ItemBrandsUpsertError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/inventory-administration/brands/{id}",
    });
  }

  /**
   * 🔒 Item Catalogs - Delete
   * [Operation: itemCatalogsDelete]
   */
  public static itemCatalogsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemCatalogsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemCatalogsDeleteResponse,
      ItemCatalogsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/catalogs/{id}",
    });
  }

  /**
   * 🔒 Item Catalogs - Upsert
   * [Operation: itemCatalogsUpsert]
   */
  public static itemCatalogsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemCatalogsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemCatalogsUpsertResponse,
      ItemCatalogsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/catalogs/{id}",
    });
  }

  /**
   * 🔒 Item Catalogs - Purge
   * [Operation: itemCatalogsPurge]
   */
  public static itemCatalogsPurge<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemCatalogsPurgeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemCatalogsPurgeResponse,
      ItemCatalogsPurgeError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/catalogs/{id}/purge",
    });
  }

  /**
   * 🔒  [INVA207] Item Categories - Delete
   * [Operation: itemCategoriesDelete]
   */
  public static itemCategoriesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemCategoriesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemCategoriesDeleteResponse,
      ItemCategoriesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/categories/{id}",
    });
  }

  /**
   * 🔒  [INVA201] Item Categories - Upsert
   * [Operation: itemCategoriesUpsert]
   */
  public static itemCategoriesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemCategoriesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemCategoriesUpsertResponse,
      ItemCategoriesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/categories/{id}",
    });
  }

  /**
   * 🔒  [INVA240] Item Image Tags - List
   * [Operation: itemImageTagsList]
   */
  public static itemImageTagsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemImageTagsListResponse,
      ItemImageTagsListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/image-tags",
    });
  }

  /**
   * 🔒  [INVA242] Item Image Tags - Delete
   * [Operation: itemImageTagsDelete]
   */
  public static itemImageTagsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemImageTagsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemImageTagsDeleteResponse,
      ItemImageTagsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/image-tags/{id}",
    });
  }

  /**
   * 🔒  [INVA241] Item Image Tags - Upsert
   * [Operation: itemImageTagsUpsert]
   */
  public static itemImageTagsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemImageTagsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemImageTagsUpsertResponse,
      ItemImageTagsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/image-tags/{id}",
    });
  }

  /**
   * 🔒 Item Departments - Delete
   * [Operation: itemDepartmentsDelete]
   */
  public static itemDepartmentsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemDepartmentsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemDepartmentsDeleteResponse,
      ItemDepartmentsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-departments/{id}",
    });
  }

  /**
   * 🔒 Item Departments - Upsert
   * [Operation: itemDepartmentsUpsert]
   */
  public static itemDepartmentsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemDepartmentsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemDepartmentsUpsertResponse,
      ItemDepartmentsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-departments/{id}",
    });
  }

  /**
   * 🔒  [INVA212] Item tags - Delete
   * [Operation: itemTagsDelete]
   */
  public static itemTagsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemTagsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemTagsDeleteResponse,
      ItemTagsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-tags/{id}",
    });
  }

  /**
   * 🔒  [INVA211] Item tags - Upsert
   * [Operation: itemTagsUpsert]
   */
  public static itemTagsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemTagsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemTagsUpsertResponse,
      ItemTagsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-tags/{id}",
    });
  }

  /**
   * 🔒  [INVA250] Item views - List
   * [Operation: itemViewsList]
   */
  public static itemViewsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemViewsListResponse,
      ItemViewsListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-views",
    });
  }

  /**
   * 🔒  [INVA252] Item PIM Views - Delete
   * [Operation: itemViewsDelete]
   */
  public static itemViewsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemViewsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemViewsDeleteResponse,
      ItemViewsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-views/{id}",
    });
  }

  /**
   * 🔒  [INVA251] Item views - Upsert
   * [Operation: itemViewsUpsert]
   */
  public static itemViewsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemViewsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemViewsUpsertResponse,
      ItemViewsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-views/{id}",
    });
  }

  /**
   * 🔒 Item views - Fields Definitions
   * [Operation: itemViewsFieldDefinitions]
   */
  public static itemViewsFieldDefinitions<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemViewsFieldDefinitionsResponse,
      ItemViewsFieldDefinitionsError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/item-views/field-definitions",
    });
  }

  /**
   * 🔒  [INVA300] Inventory Models - List
   * [Operation: inventoryModelsList]
   */
  public static inventoryModelsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      InventoryModelsListResponse,
      InventoryModelsListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/models",
    });
  }

  /**
   * 🔒  [INVA301] Inventory Models - Upsert
   * [Operation: inventoryModelsUpsert]
   */
  public static inventoryModelsUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<InventoryModelsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InventoryModelsUpsertResponse,
      InventoryModelsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/models",
    });
  }

  /**
   * 🔒  [INVA302] Inventory Models - Delete
   * [Operation: inventoryModelsDelete]
   */
  public static inventoryModelsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<InventoryModelsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      InventoryModelsDeleteResponse,
      InventoryModelsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/models/{id}",
    });
  }

  /**
   * 🔒  [INVA220] Pim Completeness - List
   * [Operation: pimCompletenessList]
   */
  public static pimCompletenessList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PimCompletenessListResponse,
      PimCompletenessListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pim-completeness",
    });
  }

  /**
   * 🔒  [INVA222] Pim Completeness - Delete
   * [Operation: pimCompletenessDelete]
   */
  public static pimCompletenessDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PimCompletenessDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PimCompletenessDeleteResponse,
      PimCompletenessDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pim-completeness/{id}",
    });
  }

  /**
   * 🔒  [INVA221] Item Completeness - Upsert
   * [Operation: pimCompletenessUpsert]
   */
  public static pimCompletenessUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PimCompletenessUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PimCompletenessUpsertResponse,
      PimCompletenessUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pim-completeness/{id}",
    });
  }

  /**
   * 🔒  [INVA500] Pricelists - List
   * [Operation: pricelistList]
   */
  public static pricelistList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PricelistListResponse,
      PricelistListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pricelists",
    });
  }

  /**
   * 🔒  [INVA501] Pricelists - Upsert
   * [Operation: pricelistUpsert]
   */
  public static pricelistUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PricelistUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistUpsertResponse,
      PricelistUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pricelists",
    });
  }

  /**
   * 🔒  [INVA502] Pricelists - Delete
   * [Operation: pricelistDelete]
   */
  public static pricelistDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PricelistDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PricelistDeleteResponse,
      PricelistDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pricelists/{id}",
    });
  }

  /**
   * 🔒  [INVA503] Pricelists - Set Default
   * [Operation: pricelistSetDefault]
   */
  public static pricelistSetDefault<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PricelistSetDefaultData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PricelistSetDefaultResponse,
      PricelistSetDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/pricelists/{id}/set-default",
    });
  }

  /**
   * 🔒  [INVA310] Inventory Profiles - List
   * [Operation: inventoryProfilesList]
   */
  public static inventoryProfilesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      InventoryProfilesListResponse,
      InventoryProfilesListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/profiles",
    });
  }

  /**
   * 🔒  [INVA311] Inventory Profiles - Upsert
   * [Operation: inventoryProfilesUpsert]
   */
  public static inventoryProfilesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<InventoryProfilesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InventoryProfilesUpsertResponse,
      InventoryProfilesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/profiles/{id}",
    });
  }

  /**
   * 🔒  [INVA312] Inventory Profiles - Delete
   * [Operation: inventoryProfilesDelete]
   */
  public static inventoryProfilesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<InventoryProfilesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      InventoryProfilesDeleteResponse,
      InventoryProfilesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/profiles/{id}",
    });
  }

  /**
   * 🔒  [INVA230] Item Specifications - List
   * [Operation: itemSpecificationsList]
   */
  public static itemSpecificationsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemSpecificationsListResponse,
      ItemSpecificationsListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/specifications",
    });
  }

  /**
   * 🔒  [INVA232] Item Specifications - Delete
   * [Operation: itemSpecificationsDelete]
   */
  public static itemSpecificationsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemSpecificationsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ItemSpecificationsDeleteResponse,
      ItemSpecificationsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/specifications/{id}",
    });
  }

  /**
   * 🔒  [INVA231] Item Specifications - Upsert
   * [Operation: itemSpecificationsUpsert]
   */
  public static itemSpecificationsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemSpecificationsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemSpecificationsUpsertResponse,
      ItemSpecificationsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/specifications/{id}",
    });
  }

  /**
   * 🔒 Item Specifications - Export
   * [Operation: itemSpecificationsExport]
   */
  public static itemSpecificationsExport<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemSpecificationsExportResponse,
      ItemSpecificationsExportError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/specifications/export",
    });
  }

  /**
   * 🔒 Item Specifications - Set Order
   * [Operation: itemSpecificationsSetOrder]
   */
  public static itemSpecificationsSetOrder<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<ItemSpecificationsSetOrderData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemSpecificationsSetOrderResponse,
      ItemSpecificationsSetOrderError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/specifications/set-order",
    });
  }

  /**
   * 🔒  [INVA400] Trc Classes - List
   * [Operation: trcClassList]
   */
  public static trcClassList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      TrcClassListResponse,
      TrcClassListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/trc-classes",
    });
  }

  /**
   * 🔒  [INVA401] Trc Classes - Upsert
   * [Operation: trcClassUpsert]
   */
  public static trcClassUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TrcClassUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TrcClassUpsertResponse,
      TrcClassUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/trc-classes/{id}",
    });
  }

  /**
   * 🔒  [INVA402] Trc Classes - Delete
   * [Operation: trcClassDelete]
   */
  public static trcClassDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<TrcClassDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      TrcClassDeleteResponse,
      TrcClassDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/trc-classes/{id}",
    });
  }

  /**
   * 🔒  [INVA100] UOM - List
   * [Operation: uomList]
   */
  public static uomList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      UomListResponse,
      UomListError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/uoms",
    });
  }

  /**
   * 🔒  [INVA101] UOM - Upsert
   * [Operation: uomUpsert]
   */
  public static uomUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<UomUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      UomUpsertResponse,
      UomUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/uoms",
    });
  }

  /**
   * 🔒  [INVA102] UOM - Delete
   * [Operation: uomDelete]
   */
  public static uomDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<UomDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      UomDeleteResponse,
      UomDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/uoms/{id}",
    });
  }

  /**
   * 🔒  [INVA103] UOM - Set Default
   * [Operation: uomSetDefault]
   */
  public static uomSetDefault<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<UomSetDefaultData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      UomSetDefaultResponse,
      UomSetDefaultError,
      ThrowOnError
    >({
      ...options,
      url: "/inventory-administration/uoms/{id}/set-default",
    });
  }
}

export class InventoryCatalogV1Service {
  /**
   * 🔒 Item App Categories - List
   * [Operation: itemAppCategoriesList]
   */
  public static itemAppCategoriesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemAppCategoriesListResponse,
      ItemAppCategoriesListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/catalog/app-categories",
      responseTransformer: ItemAppCategoriesListResponseTransformer,
    });
  }

  /**
   * 🔒 Item Brands - List
   * [Operation: itemBrandsList]
   */
  public static itemBrandsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemBrandsListResponse,
      ItemBrandsListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/catalog/brands",
    });
  }

  /**
   * 🔒 Item Catalogs - List
   * [Operation: itemCatalogsList]
   */
  public static itemCatalogsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemCatalogsListResponse,
      ItemCatalogsListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/catalog/catalogs",
    });
  }

  /**
   * 🔒 Item Categories - List
   * [Operation: itemCategoriesList]
   */
  public static itemCategoriesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemCategoriesListResponse,
      ItemCategoriesListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/catalog/categories",
    });
  }

  /**
   * 🔒 Item Departments - List
   * [Operation: itemDepartmentsList]
   */
  public static itemDepartmentsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemDepartmentsListResponse,
      ItemDepartmentsListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/catalog/item-departments",
    });
  }

  /**
   * 🔒 Item tags - list
   * [Operation: itemTagsList]
   */
  public static itemTagsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemTagsListResponse,
      ItemTagsListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/catalog/item-tags",
    });
  }
}

export class InventoryV1Service {
  /**
   * 🔒 Create item
   * [Operation: itemCreate]
   */
  public static itemCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ItemCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemCreateResponse,
      ItemCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/items/create",
    });
  }

  /**
   * 🔒 Item - Get By Sku
   * [Operation: inventoryItemsDetails]
   */
  public static inventoryItemsDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<InventoryItemsDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      InventoryItemsDetailsResponse,
      InventoryItemsDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/items/details/{sku}",
    });
  }

  /**
   * 🔒 Items List - Search
   * [Operation: inventoryItemsList]
   */
  public static inventoryItemsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<InventoryItemsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      InventoryItemsListResponse,
      InventoryItemsListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/inventory/items/list",
    });
  }
}

export class MarketplacesService {
  /**
   * 🔒  [MRT02] Marketplace details
   * [Operation: marketplaceDetails]
   */
  public static marketplaceDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplaceDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplaceDetailsResponse,
      MarketplaceDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}",
      responseTransformer: MarketplaceDetailsResponseTransformer,
    });
  }

  /**
   * 🔒  [MRT04] Amazon: FBA Inbound - Prep Instructions
   * [Operation: amazonInboundPrepInstructions]
   */
  public static amazonInboundPrepInstructions<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPrepInstructionsData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPrepInstructionsResponse2,
      AmazonInboundPrepInstructionsError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/fba-inbound/prep-instructions",
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Update prep details
   * [Operation: amazonInboundUpdatePrepDetails]
   */
  public static amazonInboundUpdatePrepDetails<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundUpdatePrepDetailsData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundUpdatePrepDetailsResponse,
      AmazonInboundUpdatePrepDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/fba/update-prep-details",
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Placement transport accept
   * [Operation: amazonInboundPlacementTransportAccept]
   */
  public static amazonInboundPlacementTransportAccept<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlacementTransportAcceptData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlacementTransportAcceptResponse,
      AmazonInboundPlacementTransportAcceptError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/placement/{trnId}/transport/accept",
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Placement transport
   * [Operation: amazonInboundPlacementTransportList]
   */
  public static amazonInboundPlacementTransportList<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlacementTransportListData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlacementTransportListResponse,
      AmazonInboundPlacementTransportListError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/placement/{trnId}/transport/list",
      responseTransformer:
        AmazonInboundPlacementTransportListResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Create Trn
   * [Operation: amazonInboundPlanCreateTrn]
   */
  public static amazonInboundPlanCreateTrn<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<AmazonInboundPlanCreateTrnData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlanCreateTrnResponse,
      AmazonInboundPlanCreateTrnError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/plans/{planId}/create-trn/{warehouseId}",
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Placement options list with details
   * [Operation: amazonInboundPlanPlacementOptionsDetailedList]
   */
  public static amazonInboundPlanPlacementOptionsDetailedList<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlanPlacementOptionsDetailedListData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlanPlacementOptionsDetailedListResponse,
      AmazonInboundPlanPlacementOptionsDetailedListError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/plans/{planId}/placement-options-detailed",
      responseTransformer:
        AmazonInboundPlanPlacementOptionsDetailedListResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Placement options details
   * [Operation: amazonInboundPlanPlacementOptionsDetails]
   */
  public static amazonInboundPlanPlacementOptionsDetails<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlanPlacementOptionsDetailsData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      AmazonInboundPlanPlacementOptionsDetailsResponse,
      AmazonInboundPlanPlacementOptionsDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/plans/{planId}/placement-options/{placementOptionId}",
      responseTransformer:
        AmazonInboundPlanPlacementOptionsDetailsResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Shipments list
   * [Operation: amazonInboundPlanShipmentsList]
   */
  public static amazonInboundPlanShipmentsList<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlanShipmentsListData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      AmazonInboundPlanShipmentsListResponse,
      AmazonInboundPlanShipmentsListError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/plans/{planId}/shipments",
      responseTransformer: AmazonInboundPlanShipmentsListResponseTransformer,
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Confirm transportation options
   * [Operation: amazonInboundPlanTransportationConfirmation]
   */
  public static amazonInboundPlanTransportationConfirmation<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlanTransportationConfirmationData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlanTransportationConfirmationResponse,
      AmazonInboundPlanTransportationConfirmationError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/plans/{planId}/transport/confirm",
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - Plan transportation options list
   * [Operation: amazonInboundPlanTransportList]
   */
  public static amazonInboundPlanTransportList<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      AmazonInboundPlanTransportListData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AmazonInboundPlanTransportListResponse,
      AmazonInboundPlanTransportListError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/amazon/inbound/plans/{planId}/transport/list",
      responseTransformer: AmazonInboundPlanTransportListResponseTransformer,
    });
  }

  /**
   * 🔒  [MRT01] Marketplace listings
   * [Operation: marketplaceListingsList]
   */
  public static marketplaceListingsList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplaceListingsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      MarketplaceListingsListResponse,
      MarketplaceListingsListError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/listings",
    });
  }

  /**
   * 🔒  [MRT10] Marketplace listings bulk
   * [Operation: marketplaceListingsLoad]
   */
  public static marketplaceListingsLoad<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<MarketplaceListingsLoadData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      MarketplaceListingsLoadResponse,
      MarketplaceListingsLoadError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/{mpId}/listings",
    });
  }

  /**
   * 🔒 Amazon: FBA Inbound - List TRN
   * [Operation: amazonInboundDocumentList]
   */
  public static amazonInboundDocumentList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<AmazonInboundDocumentListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AmazonInboundDocumentListResponse,
      AmazonInboundDocumentListError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/amazon/fba-inbound",
      responseTransformer: AmazonInboundDocumentListResponseTransformer,
    });
  }

  /**
   * 🔒 Linked services
   */
  public static getMarketplacesLinkedServices<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetMarketplacesLinkedServicesResponse,
      GetMarketplacesLinkedServicesError,
      ThrowOnError
    >({
      ...options,
      url: "/marketplaces/linked-services",
    });
  }
}

export class OutboundService {
  /**
   * Carrier - upload attachments
   * [Operation: carrierAttachments]
   */
  public static carrierAttachments<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CarrierAttachmentsData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CarrierAttachmentsResponse,
      CarrierAttachmentsError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/outbound/carrier/attachments/{shpId}",
    });
  }

  /**
   * Carrier - documents list
   * [Operation: carrierDocuments]
   */
  public static carrierDocuments<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CarrierDocumentsResponse,
      CarrierDocumentsError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/carrier/documents",
      responseTransformer: CarrierDocumentsResponseTransformer,
    });
  }

  /**
   * Carrier - shipment validation
   * [Operation: carrierValidate]
   */
  public static carrierValidate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<CarrierValidateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CarrierValidateResponse,
      CarrierValidateError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/carrier/shipments/{shpId}/validate",
    });
  }

  /**
   * SO Trending
   */
  public static getOutboundDocumentSoDocumentidTrends<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      GetOutboundDocumentSoDocumentidTrendsData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetOutboundDocumentSoDocumentidTrendsResponse,
      GetOutboundDocumentSoDocumentidTrendsError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/document/so/{documentId}/trends",
      responseTransformer:
        GetOutboundDocumentSoDocumentidTrendsResponseTransformer,
    });
  }

  /**
   * 🔒
   * [Operation: invoicesCreate]
   */
  public static invoicesCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<InvoicesCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InvoicesCreateResponse2,
      InvoicesCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/invoices",
    });
  }

  /**
   * 🔒
   * [Operation: invoicesEmail]
   */
  public static invoicesEmail<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<InvoicesEmailData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      InvoicesEmailResponse,
      InvoicesEmailError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/invoices/email",
    });
  }

  /**
   *  [OUT32] Get a packing document
   * [Operation: getPackingDocument]
   */
  public static getPackingDocument<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<GetPackingDocumentData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetPackingDocumentResponse,
      GetPackingDocumentError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/pack/{baseType}/{baseId}",
      responseTransformer: GetPackingDocumentResponseTransformer,
    });
  }

  /**
   * 🔒 Packages, Unassigned - Plan
   * [Operation: packagesUnassignPlan]
   */
  public static packagesUnassignPlan<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PackagesUnassignPlanData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PackagesUnassignPlanResponse,
      PackagesUnassignPlanError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/packages/unassign/plan",
    });
  }

  /**
   * 🔒 Packages, Unassigned - Save
   * [Operation: packagesUnassignSave]
   */
  public static packagesUnassignSave<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PackagesUnassignSaveData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PackagesUnassignSaveResponse,
      PackagesUnassignSaveError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/packages/unassign/save",
    });
  }

  /**
   * 🔒 Packages, Unassigned - List
   * [Operation: packagesUnassignList]
   */
  public static packagesUnassignList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PackagesUnassignListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PackagesUnassignListResponse,
      PackagesUnassignListError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/packages/unassigned/list",
      responseTransformer: PackagesUnassignListResponseTransformer,
    });
  }

  /**
   *  [OUT31] Palletize packages
   * [Operation: packagesPalletize]
   */
  public static packagesPalletize<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PackagesPalletizeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PackagesPalletizeResponse,
      PackagesPalletizeError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/palletize",
    });
  }

  /**
   * 🔒  [OUTPW01] Pick Workflows - List
   * [Operation: pickWorkflowsList]
   */
  public static pickWorkflowsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PickWorkflowsListResponse,
      PickWorkflowsListError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/pick-workflows",
    });
  }

  /**
   * 🔒  [OUTPW04] Pick Workflows - Delete
   * [Operation: pickWorkflowsDelete]
   */
  public static pickWorkflowsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PickWorkflowsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PickWorkflowsDeleteResponse,
      PickWorkflowsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/pick-workflows/{id}",
    });
  }

  /**
   * 🔒 Pick Workflows - Upsert
   * [Operation: pickWorkflowsUpsert]
   */
  public static pickWorkflowsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PickWorkflowsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PickWorkflowsUpsertResponse,
      PickWorkflowsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/pick-workflows/{id}",
    });
  }

  /**
   * 🔒  [OUTPW03] Pick Workflows - Trigger
   * [Operation: pickWorkflowsTrigger]
   */
  public static pickWorkflowsTrigger<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PickWorkflowsTriggerData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PickWorkflowsTriggerResponse,
      PickWorkflowsTriggerError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/pick-workflows/{id}/trigger",
    });
  }

  /**
   * 🔒 Shipments - Import Shipments
   * [Operation: shipmentsImport]
   */
  public static shipmentsImport<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ShipmentsImportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ShipmentsImportResponse,
      ShipmentsImportError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/shipments/import",
    });
  }

  /**
   * 🔒  [OUT25D] Sales Order - Get
   * [Operation: salesOrderGet]
   */
  public static salesOrderGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SalesOrderGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SalesOrderGetResponse,
      SalesOrderGetError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/so/{documentId}",
      responseTransformer: SalesOrderGetResponseTransformer,
    });
  }

  /**
   * 🔒  [OUT13] Attach draft shipment to SO
   * Use to attach shipment labels that were generated externally
   * [Operation: salesOrderAttachDraftShipment]
   */
  public static salesOrderAttachDraftShipment<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      SalesOrderAttachDraftShipmentData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      SalesOrderAttachDraftShipmentResponse,
      SalesOrderAttachDraftShipmentError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/so/{documentId}/draft-shipment",
    });
  }

  /**
   * 🔒  [OUT28] Generate new draft shipment to SO
   * [Operation: salesOrderCreateDraftShipment]
   */
  public static salesOrderCreateDraftShipment<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      SalesOrderCreateDraftShipmentData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      SalesOrderCreateDraftShipmentResponse,
      SalesOrderCreateDraftShipmentError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/so/{documentId}/generate-draft-shipment",
    });
  }

  /**
   *  [OUT25C] Sales Order - Create
   * [Operation: salesOrderCreate]
   */
  public static salesOrderCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<SalesOrderCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SalesOrderCreateResponse,
      SalesOrderCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/outbound/so/create",
    });
  }
}

export class OutboundV1Service {
  /**
   * 🔒 Packages - Delete
   * [Operation: packagesDelete]
   */
  public static packagesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PackagesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PackagesDeleteResponse,
      PackagesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/packages/delete",
    });
  }

  /**
   * 🔒 PCK - Delete
   * [Operation: pckDelete]
   */
  public static pckDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PckDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      PckDeleteResponse,
      PckDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/{pckId}",
    });
  }

  /**
   * 🔒 PCK - Unclaim
   * [Operation: pckUnclaim]
   */
  public static pckUnclaim<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PckUnclaimData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      PckUnclaimResponse,
      PckUnclaimError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/{pckId}/unclaim",
    });
  }

  /**
   * 🔒 PCK - List Active
   * [Operation: pckActiveList]
   */
  public static pckActiveList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      PckActiveListResponse,
      PckActiveListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/active",
      responseTransformer: PckActiveListResponseTransformer,
    });
  }

  /**
   * 🔒 PCK - Create
   * [Operation: pckCreate]
   */
  public static pckCreate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PckCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PckCreateResponse,
      PckCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/create",
    });
  }

  /**
   * 🔒 PCK - Merge
   * [Operation: pckMerge]
   */
  public static pckMerge<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PckMergeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PckMergeResponse,
      PckMergeError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/merge",
    });
  }

  /**
   * 🔒 PCK - Scheduled, Upsert
   * [Operation: pckScheduledUpsert]
   */
  public static pckScheduledUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PckScheduledUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PckScheduledUpsertResponse,
      PckScheduledUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/scheduled/upsert/{id}",
    });
  }

  /**
   * 🔒 PCK - Scheduled, Assign
   * [Operation: pckScheduledAssignment]
   */
  public static pckScheduledAssignment<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<PckScheduledAssignmentData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PckScheduledAssignmentResponse,
      PckScheduledAssignmentError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/outbound/pck/schedulled/assign",
    });
  }
}

export class PortalService {
  /**
   *  [POR05] Account: Get details
   * [Operation: accountDetails]
   */
  public static accountDetails<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AccountDetailsResponse,
      AccountDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/account/details",
    });
  }

  /**
   *  [POR06] Account: Get invoices
   * [Operation: listInvoices]
   */
  public static listInvoices<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ListInvoicesResponse,
      ListInvoicesError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/account/invoices",
      responseTransformer: ListInvoicesResponseTransformer,
    });
  }

  /**
   *  [POR08] Account: Get orders
   * [Operation: listOrders]
   */
  public static listOrders<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ListOrdersResponse,
      ListOrdersError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/account/orders",
      responseTransformer: ListOrdersResponseTransformer,
    });
  }

  /**
   *  [POR09] Download order
   * [Operation: downloadOrder]
   */
  public static downloadOrder<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<DownloadOrderData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      DownloadOrderResponse,
      DownloadOrderError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/account/orders/{soId}",
    });
  }

  /**
   * 🔓  [POR01] Portal Authentication
   * [Operation: authenticate]
   */
  public static authenticate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<AuthenticateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AuthenticateResponse,
      AuthenticateError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/authenticate",
    });
  }

  /**
   *  [POR10] Clear basket
   * [Operation: clearBasket]
   */
  public static clearBasket<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ClearBasketResponse,
      ClearBasketError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/basket",
    });
  }

  /**
   *  [POR14] Basket content
   * [Operation: basket]
   */
  public static basket<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      BasketResponse,
      BasketError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/basket",
    });
  }

  /**
   *  [POR15] Add or remove items from basket
   * [Operation: basketSet]
   */
  public static basketSet<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<BasketSetData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      BasketSetResponse,
      BasketSetError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/basket",
    });
  }

  /**
   *  [POR11] Basket summary
   * [Operation: basketSummary]
   */
  public static basketSummary<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      BasketSummaryResponse,
      BasketSummaryError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/basket-summary",
    });
  }

  /**
   *  [POR13] Catalog
   * [Operation: catalog]
   */
  public static catalog<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CatalogData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CatalogResponse,
      CatalogError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/catalog",
      responseTransformer: CatalogResponseTransformer,
    });
  }

  /**
   *  [POR16] Catalog items
   * [Operation: catalogItems]
   */
  public static catalogItems<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CatalogItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      CatalogItemsResponse,
      CatalogItemsError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/catalog/items",
      responseTransformer: CatalogItemsResponseTransformer,
    });
  }

  /**
   *  [POR12] Basket checkout
   * [Operation: checkout]
   */
  public static checkout<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<CheckoutData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CheckoutResponse,
      CheckoutError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/checkout",
    });
  }

  /**
   * 🔓  [POR02] Forgot Password
   * [Operation: forgotPassword]
   */
  public static forgotPassword<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ForgotPasswordData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ForgotPasswordResponse,
      ForgotPasswordError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/forgot-password",
    });
  }

  /**
   * 🔓 Portal Info
   * [Operation: portalInfo]
   */
  public static portalInfo<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<PortalInfoData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      PortalInfoResponse,
      PortalInfoError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/info",
    });
  }

  /**
   *  [POR201] Get Item specs
   * [Operation: itemSpecs]
   */
  public static itemSpecs<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemSpecsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ItemSpecsResponse,
      ItemSpecsError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/item-specs/{sku}",
    });
  }

  /**
   * 🔓  [POR03] Reset Password
   * [Operation: resetPassword]
   */
  public static resetPassword<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ResetPasswordData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ResetPasswordResponse,
      ResetPasswordError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/password-reset",
    });
  }

  /**
   * 🔓  [POR18] Portal Token Authentication
   * [Operation: tokenAuthentication]
   */
  public static tokenAuthentication<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<TokenAuthenticationData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      TokenAuthenticationResponse2,
      TokenAuthenticationError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/token-authentication",
    });
  }

  /**
   *  [POR30] Token Info
   * [Operation: userInfo]
   */
  public static userInfo<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      UserInfoResponse,
      UserInfoError,
      ThrowOnError
    >({
      ...options,
      url: "/portal/user-info",
    });
  }
}

export class ReportsService {
  /**
   * 🔒 AI Conversations - Start new conversation
   * [Operation: aiConversationCreate]
   */
  public static aiConversationCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      AiConversationCreateResponse,
      AiConversationCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/ai-conversations/create",
    });
  }

  /**
   * 🔒 AI Conversations - Send message
   * [Operation: aiConversationMessage]
   */
  public static aiConversationMessage<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<AiConversationMessageData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AiConversationMessageResponse,
      AiConversationMessageError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/ai-conversations/message",
    });
  }

  /**
   * 🔒 AI Conversations - Message export
   * [Operation: aiConversationMessageExport]
   */
  public static aiConversationMessageExport<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<AiConversationMessageExportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AiConversationMessageExportResponse,
      AiConversationMessageExportError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/ai-conversations/message-export",
    });
  }

  /**
   * 🔒 AI Conversations - Message feedback
   * [Operation: aiConversationMessageFeedback]
   */
  public static aiConversationMessageFeedback<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<
      AiConversationMessageFeedbackData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      AiConversationMessageFeedbackResponse,
      AiConversationMessageFeedbackError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/ai-conversations/message-feedback",
    });
  }

  /**
   * 🔒 AI Conversations - Retry message
   * [Operation: aiConversationMessageRetry]
   */
  public static aiConversationMessageRetry<
    ThrowOnError extends boolean = false,
  >(
    options?: OptionsLegacyParser<AiConversationMessageRetryData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AiConversationMessageRetryResponse,
      AiConversationMessageRetryError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/ai-conversations/message-retry",
    });
  }

  /**
   * Run custom feed
   */
  public static getReportsCustomFeedIdKey<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<GetReportsCustomFeedIdKeyData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetReportsCustomFeedIdKeyResponse,
      GetReportsCustomFeedIdKeyError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/custom-feed/{id}/{key}",
    });
  }

  /**
   * 🔒 KPI Dashboards - Create
   * [Operation: kpiDashboardCreate]
   */
  public static kpiDashboardCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<KpiDashboardCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      KpiDashboardCreateResponse,
      KpiDashboardCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard",
    });
  }

  /**
   * 🔒 KPI Dashboards - List
   * [Operation: kpiDashboardList]
   */
  public static kpiDashboardList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      KpiDashboardListResponse,
      KpiDashboardListError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard",
    });
  }

  /**
   * 🔒 KPI Dashboards - delete widget
   * [Operation: kpiDashboardWidgetsDelete]
   */
  public static kpiDashboardWidgetsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardWidgetsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      KpiDashboardWidgetsDeleteResponse,
      KpiDashboardWidgetsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{dashboardId}/widget/{widgetId}",
    });
  }

  /**
   * 🔒 KPI Dashboard - upsert widget
   * [Operation: kpiDashboardWidgetsUpsert]
   */
  public static kpiDashboardWidgetsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardWidgetsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      KpiDashboardWidgetsUpsertResponse,
      KpiDashboardWidgetsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{dashboardId}/widget/{widgetId}",
    });
  }

  /**
   * 🔒 KPI Dashboards - list widgets
   * [Operation: kpiDashboardWidgetsList]
   */
  public static kpiDashboardWidgetsList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardWidgetsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      KpiDashboardWidgetsListResponse,
      KpiDashboardWidgetsListError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{dashboardId}/widgets",
    });
  }

  /**
   * 🔒 KPI Dashboards - Delete
   * [Operation: kpiDashboardDelete]
   */
  public static kpiDashboardDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      KpiDashboardDeleteResponse,
      KpiDashboardDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{id}",
    });
  }

  /**
   * 🔒 KPI Dashboards - Update
   * [Operation: kpiDashboardUpdate]
   */
  public static kpiDashboardUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      KpiDashboardUpdateResponse,
      KpiDashboardUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{id}",
    });
  }

  /**
   * 🔓 KPI Dashboard - Get
   * [Operation: kpiDashboard]
   */
  public static kpiDashboard<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      KpiDashboardResponse,
      KpiDashboardError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{token}",
    });
  }

  /**
   * 🔓  [RPT20] KPI Widget value
   * [Operation: kpiDashboardWidgetsValue]
   */
  public static kpiDashboardWidgetsValue<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<KpiDashboardWidgetsValueData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      KpiDashboardWidgetsValueResponse,
      KpiDashboardWidgetsValueError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{token}/value/{widgetId}",
    });
  }

  /**
   * 🔓  [RPT19] KPI Dashboard - update widgets position
   * [Operation: kpiDashboardWidgetsUpdatePosition]
   */
  public static kpiDashboardWidgetsUpdatePosition<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      KpiDashboardWidgetsUpdatePositionData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).put<
      KpiDashboardWidgetsUpdatePositionResponse,
      KpiDashboardWidgetsUpdatePositionError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/{token}/widgets",
    });
  }

  /**
   * 🔓 List widget types
   * [Operation: widgetTypes]
   */
  public static widgetTypes<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WidgetTypesResponse,
      WidgetTypesError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/kpi-dashboard/list-widget-types",
      responseTransformer: WidgetTypesResponseTransformer,
    });
  }

  /**
   * 🔒 List report types
   */
  public static getReportsListTypes<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetReportsListTypesResponse,
      GetReportsListTypesError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/list-types",
      responseTransformer: GetReportsListTypesResponseTransformer,
    });
  }

  /**
   * Report server - Items
   */
  public static getReportsReportServerItems<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<GetReportsReportServerItemsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetReportsReportServerItemsResponse,
      GetReportsReportServerItemsError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/report-server/items",
    });
  }

  /**
   *  [RPT30] Report server - Sales
   */
  public static getReportsReportServerSales<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<GetReportsReportServerSalesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetReportsReportServerSalesResponse,
      GetReportsReportServerSalesError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/report-server/sales",
    });
  }

  /**
   * 🔒 Report templates - List
   * [Operation: reportTemplatesNamesList]
   */
  public static reportTemplatesNamesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ReportTemplatesNamesListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReportTemplatesNamesListResponse,
      ReportTemplatesNamesListError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/report-templates",
    });
  }

  /**
   * 🔒 Run report
   * [Operation: runReport]
   */
  public static runReport<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<RunReportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      RunReportResponse,
      RunReportError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/run-report",
    });
  }

  /**
   * 🔒  [RPT29] Sales report drill down
   * [Operation: itemSalesDrillDown]
   */
  public static itemSalesDrillDown<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemSalesDrillDownData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemSalesDrillDownResponse,
      ItemSalesDrillDownError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-drill-down/{itemSku}",
      responseTransformer: ItemSalesDrillDownResponseTransformer,
    });
  }

  /**
   * 🔒  [RPT29S] Sales report drill down summary
   * [Operation: itemSalesDrillDownSummary]
   */
  public static itemSalesDrillDownSummary<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ItemSalesDrillDownSummaryData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ItemSalesDrillDownSummaryResponse,
      ItemSalesDrillDownSummaryError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-drill-down/{itemSku}/summary/{summaryType}",
    });
  }

  /**
   * 🔒  [RPT12] Get sales top performance by section
   * [Operation: salesOverviewPerformanceBySection]
   */
  public static salesOverviewPerformanceBySection<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      SalesOverviewPerformanceBySectionData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      SalesOverviewPerformanceBySectionResponse,
      SalesOverviewPerformanceBySectionError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-overview/performance/{section}",
    });
  }

  /**
   * 🔒  [RPT17] Get sales performance for each day
   */
  public static getReportsSalesOverviewPerformanceDaily<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      GetReportsSalesOverviewPerformanceDailyData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetReportsSalesOverviewPerformanceDailyResponse,
      GetReportsSalesOverviewPerformanceDailyError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-overview/performance/daily",
    });
  }

  /**
   * 🔒  [RPT11] Get sales top performing items
   * [Operation: salesOverviewPerformanceByItem]
   */
  public static salesOverviewPerformanceByItem<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      SalesOverviewPerformanceByItemData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      SalesOverviewPerformanceByItemResponse,
      SalesOverviewPerformanceByItemError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-overview/performance/items",
    });
  }

  /**
   * 🔒  [RPT25] Get sales overview summary
   * [Operation: salesOverviewSummaryByDate]
   */
  public static salesOverviewSummaryByDate<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<SalesOverviewSummaryByDateData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SalesOverviewSummaryByDateResponse,
      SalesOverviewSummaryByDateError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-overview/summary",
    });
  }

  /**
   * 🔒  [RPT26] Get sales overview summary by preset date range
   * [Operation: salesOverviewSummary]
   */
  public static salesOverviewSummary<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SalesOverviewSummaryData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SalesOverviewSummaryResponse,
      SalesOverviewSummaryError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/sales-overview/summary/{range}",
      responseTransformer: SalesOverviewSummaryResponseTransformer,
    });
  }

  /**
   * 🔒 Scheduled reports - Create
   * [Operation: scheduledReportsCreate]
   */
  public static scheduledReportsCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ScheduledReportsCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ScheduledReportsCreateResponse,
      ScheduledReportsCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/schedules",
    });
  }

  /**
   * 🔒 Scheduled reports - List
   * [Operation: scheduledReportsList]
   */
  public static scheduledReportsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ScheduledReportsListResponse,
      ScheduledReportsListError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/schedules",
      responseTransformer: ScheduledReportsListResponseTransformer,
    });
  }

  /**
   * 🔒 Scheduled reports - Delete
   * [Operation: scheduledReportsDelete]
   */
  public static scheduledReportsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ScheduledReportsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      ScheduledReportsDeleteResponse,
      ScheduledReportsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/schedules/{id}",
    });
  }

  /**
   * 🔒 Scheduled reports - Get
   * [Operation: scheduledReportsGet]
   */
  public static scheduledReportsGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ScheduledReportsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ScheduledReportsGetResponse,
      ScheduledReportsGetError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/schedules/{id}",
      responseTransformer: ScheduledReportsGetResponseTransformer,
    });
  }

  /**
   * 🔒 Scheduled reports - Update
   * [Operation: scheduledReportsUpdate]
   */
  public static scheduledReportsUpdate<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ScheduledReportsUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      ScheduledReportsUpdateResponse,
      ScheduledReportsUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/schedules/{id}",
    });
  }

  /**
   * 🔒 Scheduled reports - Execute
   */
  public static postReportsSchedulesIdExecute<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      PostReportsSchedulesIdExecuteData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).post<
      PostReportsSchedulesIdExecuteResponse,
      PostReportsSchedulesIdExecuteError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/schedules/{id}/execute",
    });
  }

  /**
   * 🔒 SO heat-map report
   */
  public static getReportsSoCustomerPeriodicSoid<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      GetReportsSoCustomerPeriodicSoidData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetReportsSoCustomerPeriodicSoidResponse,
      GetReportsSoCustomerPeriodicSoidError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/so-customer-periodic/{soId}",
      responseTransformer: GetReportsSoCustomerPeriodicSoidResponseTransformer,
    });
  }

  /**
   * 🔒  [RPT23] Mark system alerts as dismissed for an entire group
   */
  public static putReportsSystemAlertsDismissGroup<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      PutReportsSystemAlertsDismissGroupData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).put<
      PutReportsSystemAlertsDismissGroupResponse,
      PutReportsSystemAlertsDismissGroupError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/system-alerts/dismiss-group",
    });
  }

  /**
   * 🔒  [RPT24] Mark system alert as dismissed by alert id
   */
  public static putReportsSystemAlertsDismissMessage<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      PutReportsSystemAlertsDismissMessageData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).put<
      PutReportsSystemAlertsDismissMessageResponse,
      PutReportsSystemAlertsDismissMessageError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/system-alerts/dismiss-message",
    });
  }

  /**
   * 🔒  [RPT21] List system alerts grouped by type
   */
  public static getReportsSystemAlertsGroups<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      GetReportsSystemAlertsGroupsResponse,
      GetReportsSystemAlertsGroupsError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/system-alerts/groups",
      responseTransformer: GetReportsSystemAlertsGroupsResponseTransformer,
    });
  }

  /**
   * 🔒  [RPT22] List system alert messages within a group
   */
  public static getReportsSystemAlertsMessages<
    ThrowOnError extends boolean = false,
  >(
    options: OptionsLegacyParser<
      GetReportsSystemAlertsMessagesData,
      ThrowOnError
    >
  ) {
    return (options?.client ?? client).get<
      GetReportsSystemAlertsMessagesResponse,
      GetReportsSystemAlertsMessagesError,
      ThrowOnError
    >({
      ...options,
      url: "/reports/system-alerts/messages",
      responseTransformer: GetReportsSystemAlertsMessagesResponseTransformer,
    });
  }
}

export class SalesOrdersV1Service {
  /**
   * 🔒 Sales Orders - List
   * [Operation: salesOrdersList]
   */
  public static salesOrdersList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<SalesOrdersListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SalesOrdersListResponse,
      SalesOrdersListError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/sales-orders/sales-order/list",
      responseTransformer: SalesOrdersListResponseTransformer,
    });
  }

  /**
   * 🔒 Sales Order - Merge
   * [Operation: salesOrderMerge]
   */
  public static salesOrderMerge<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<SalesOrderMergeData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SalesOrderMergeResponse,
      SalesOrderMergeError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/sales-orders/sales-order/merge",
    });
  }

  /**
   * 🔒 Sales Order - Merge Suggestions
   * [Operation: salesOrderMergeSuggestions]
   */
  public static salesOrderMergeSuggestions<
    ThrowOnError extends boolean = false,
  >(options?: OptionsLegacyParser<unknown, ThrowOnError>) {
    return (options?.client ?? client).get<
      SalesOrderMergeSuggestionsResponse,
      SalesOrderMergeSuggestionsError,
      ThrowOnError
    >({
      ...options,
      url: "/v1/sales-orders/sales-order/merge/suggestions",
    });
  }
}

export class SegmentsService {
  /**
   * 🔒 Segments - Upsert
   * [Operation: segmentsUpsert]
   */
  public static segmentsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SegmentsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SegmentsUpsertResponse,
      SegmentsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/segments/{id}",
    });
  }

  /**
   * 🔒 Segments - Get
   * [Operation: segmentsGet]
   */
  public static segmentsGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SegmentsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SegmentsGetResponse,
      SegmentsGetError,
      ThrowOnError
    >({
      ...options,
      url: "/segments/{id}",
    });
  }

  /**
   * 🔒 Segments - List
   * [Operation: segmentsList]
   */
  public static segmentsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<SegmentsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SegmentsListResponse,
      SegmentsListError,
      ThrowOnError
    >({
      ...options,
      url: "/segments/search",
    });
  }
}

export class UserService {
  /**
   * 🔒 API Token - Create
   * [Operation: apiTokenCreate]
   */
  public static apiTokenCreate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ApiTokenCreateData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ApiTokenCreateResponse2,
      ApiTokenCreateError,
      ThrowOnError
    >({
      ...options,
      url: "/user/api-token/create",
      responseTransformer: ApiTokenCreateResponseTransformer,
    });
  }

  /**
   * 🔒 API Token - Details
   * [Operation: apiTokenDetails]
   */
  public static apiTokenDetails<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ApiTokenDetailsResponse2,
      ApiTokenDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/user/api-token/details",
      responseTransformer: ApiTokenDetailsResponseTransformer,
    });
  }

  /**
   * 🔒 API Token - Update
   * [Operation: apiTokenUpdate]
   */
  public static apiTokenUpdate<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<ApiTokenUpdateData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      ApiTokenUpdateResponse,
      ApiTokenUpdateError,
      ThrowOnError
    >({
      ...options,
      url: "/user/api-token/update",
    });
  }

  /**
   * 🔒  [USR09] Columns display settings
   * [Operation: columnDisplay]
   */
  public static columnDisplay<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<ColumnDisplayData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ColumnDisplayResponse,
      ColumnDisplayError,
      ThrowOnError
    >({
      ...options,
      url: "/user/data-columns/{viewName}",
    });
  }

  /**
   * 🔒  [USR23] Request email validation
   * [Operation: emailValidationRequest]
   */
  public static emailValidationRequest<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      EmailValidationRequestResponse,
      EmailValidationRequestError,
      ThrowOnError
    >({
      ...options,
      url: "/user/email-validation-request",
    });
  }

  /**
   *  [USR08M] User information
   * [Operation: selfInfo]
   */
  public static selfInfo<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SelfInfoResponse,
      SelfInfoError,
      ThrowOnError
    >({
      ...options,
      url: "/user/me",
    });
  }

  /**
   * 🔒 Messages outbox
   * [Operation: queuedMessages]
   */
  public static queuedMessages<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<QueuedMessagesData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      QueuedMessagesResponse,
      QueuedMessagesError,
      ThrowOnError
    >({
      ...options,
      url: "/user/messages-outbox",
      responseTransformer: QueuedMessagesResponseTransformer,
    });
  }

  /**
   * 🔒 Messages outbox - Body
   * [Operation: queuedMessagesBody]
   */
  public static queuedMessagesBody<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<QueuedMessagesBodyData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      QueuedMessagesBodyResponse,
      QueuedMessagesBodyError,
      ThrowOnError
    >({
      ...options,
      url: "/user/messages-outbox/{id}",
    });
  }

  /**
   * 🔒 Messages outbox - Delete
   * [Operation: queuedMessagesDelete]
   */
  public static queuedMessagesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<QueuedMessagesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      QueuedMessagesDeleteResponse,
      QueuedMessagesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/user/messages-outbox/{id}",
    });
  }

  /**
   * 🔒 Messages outbox - Dismiss
   * [Operation: queuedMessagesDismiss]
   */
  public static queuedMessagesDismiss<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<QueuedMessagesDismissData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      QueuedMessagesDismissResponse,
      QueuedMessagesDismissError,
      ThrowOnError
    >({
      ...options,
      url: "/user/messages-outbox/{id}/dismiss",
    });
  }

  /**
   * 🔒 Messages outbox - Re-queue
   * [Operation: queuedMessagesRequeue]
   */
  public static queuedMessagesRequeue<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<QueuedMessagesRequeueData, ThrowOnError>
  ) {
    return (options?.client ?? client).put<
      QueuedMessagesRequeueResponse,
      QueuedMessagesRequeueError,
      ThrowOnError
    >({
      ...options,
      url: "/user/messages-outbox/{id}/re-queue",
    });
  }

  /**
   * 🔒  [USR26] User notifications
   * [Operation: notifications]
   */
  public static notifications<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<NotificationsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      NotificationsResponse,
      NotificationsError,
      ThrowOnError
    >({
      ...options,
      url: "/user/notifications",
      responseTransformer: NotificationsResponseTransformer,
    });
  }

  /**
   * 🔒  [USR25] User notifications count
   * [Operation: notificationsCount]
   */
  public static notificationsCount<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      NotificationsCountResponse,
      NotificationsCountError,
      ThrowOnError
    >({
      ...options,
      url: "/user/notifications-count",
    });
  }

  /**
   * 🔒 Support ticket
   * [Operation: supportTicketsReply]
   */
  public static supportTicketsReply<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<SupportTicketsReplyData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SupportTicketsReplyResponse,
      SupportTicketsReplyError,
      ThrowOnError
    >({
      ...options,
      ...formDataBodySerializer,
      headers: {
        "Content-Type": null,
        ...options?.headers,
      },
      url: "/user/support-ticket",
    });
  }

  /**
   * 🔒 Get user support ticket
   * [Operation: supportTicketGet]
   */
  public static supportTicketGet<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<SupportTicketGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SupportTicketGetResponse,
      SupportTicketGetError,
      ThrowOnError
    >({
      ...options,
      url: "/user/support-ticket/{ticketId}",
      responseTransformer: SupportTicketGetResponseTransformer,
    });
  }

  /**
   * 🔒 List support tickets
   * [Operation: supportTicketsList]
   */
  public static supportTicketsList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<SupportTicketsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      SupportTicketsListResponse,
      SupportTicketsListError,
      ThrowOnError
    >({
      ...options,
      url: "/user/support-ticket/list",
      responseTransformer: SupportTicketsListResponseTransformer,
    });
  }
}

export class WmsService {
  /**
   * 🔒 Warehouse Groups - List
   * [Operation: warehouseGroups]
   */
  public static warehouseGroups<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WarehouseGroupsResponse,
      WarehouseGroupsError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouse-groups",
    });
  }

  /**
   * 🔒 Warehouse Groups - Upsert
   * [Operation: warehouseGroupUpsert]
   */
  public static warehouseGroupUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<WarehouseGroupUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WarehouseGroupUpsertResponse,
      WarehouseGroupUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouse-groups",
    });
  }

  /**
   * 🔒 Warehouse Groups - Delete
   * [Operation: warehouseGroupsDelete]
   */
  public static warehouseGroupsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseGroupsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      WarehouseGroupsDeleteResponse,
      WarehouseGroupsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouse-groups/{groupId}",
    });
  }

  /**
   * 🔒 Warehouses - List
   * [Operation: warehousesList]
   */
  public static warehousesList<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WarehousesListResponse,
      WarehousesListError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses",
    });
  }

  /**
   * 🔒 Warehouses - Upsert
   * [Operation: warehouseUpsert]
   */
  public static warehouseUpsert<ThrowOnError extends boolean = false>(
    options?: OptionsLegacyParser<WarehouseUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WarehouseUpsertResponse,
      WarehouseUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses",
    });
  }

  /**
   * 🔒 Warehouses - Get details
   * [Operation: warehousesDetails]
   */
  public static warehousesDetails<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehousesDetailsData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WarehousesDetailsResponse,
      WarehousesDetailsError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{id}",
    });
  }

  /**
   * 🔒 Warehouses - Delete
   * [Operation: warehousesDelete]
   */
  public static warehousesDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehousesDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      WarehousesDeleteResponse,
      WarehousesDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}",
    });
  }

  /**
   * 🔒 Warehouse bins - Upsert
   * [Operation: warehouseBinsUpsert]
   */
  public static warehouseBinsUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseBinsUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WarehouseBinsUpsertResponse,
      WarehouseBinsUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/bins",
    });
  }

  /**
   * 🔒 Warehouse bins - List names
   * [Operation: warehouseBinsList]
   */
  public static warehouseBinsList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseBinsListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WarehouseBinsListResponse,
      WarehouseBinsListError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/bins-list",
    });
  }

  /**
   * 🔒 Warehouse bins - Search
   * [Operation: warehouseBinsSearch]
   */
  public static warehouseBinsSearch<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseBinsSearchData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WarehouseBinsSearchResponse,
      WarehouseBinsSearchError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/bins-search",
      responseTransformer: WarehouseBinsSearchResponseTransformer,
    });
  }

  /**
   * 🔒 Warehouse bins - Delete
   * [Operation: warehouseBinsDelete]
   */
  public static warehouseBinsDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseBinsDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      WarehouseBinsDeleteResponse,
      WarehouseBinsDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/bins/{binId}",
    });
  }

  /**
   * 🔒 Warehouse bins - Import
   * [Operation: warehouseBinsImport]
   */
  public static warehouseBinsImport<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseBinsImportData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WarehouseBinsImportResponse,
      WarehouseBinsImportError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/bins/import",
    });
  }

  /**
   * 🔒 Warehouse zones - List
   * [Operation: warehouseZonesList]
   */
  public static warehouseZonesList<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseZonesListData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      WarehouseZonesListResponse,
      WarehouseZonesListError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/zones",
    });
  }

  /**
   * 🔒 Warehouse zones - Delete
   * [Operation: warehouseZoneDelete]
   */
  public static warehouseZoneDelete<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseZoneDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      WarehouseZoneDeleteResponse,
      WarehouseZoneDeleteError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/zones/{zoneId}",
    });
  }

  /**
   * 🔒 Warehouse zone - Upsert
   * [Operation: warehouseZonesUpsert]
   */
  public static warehouseZonesUpsert<ThrowOnError extends boolean = false>(
    options: OptionsLegacyParser<WarehouseZonesUpsertData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      WarehouseZonesUpsertResponse,
      WarehouseZonesUpsertError,
      ThrowOnError
    >({
      ...options,
      url: "/wms/warehouses/{warehouseId}/zones/{zoneId}",
    });
  }
}
